(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    globalThis['kotlinx-serialization-kotlinx-serialization-json'] = factory(typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined' ? {} : globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var EmptySerializersModule = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var VOID = kotlin_kotlin.$_$.d;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var StringFormat = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z2;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var charSequenceGet = kotlin_kotlin.$_$.kf;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var equals = kotlin_kotlin.$_$.sf;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var Enum = kotlin_kotlin.$_$.en;
  var Decoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var CompositeDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var hashCode = kotlin_kotlin.$_$.bg;
  var joinToString = kotlin_kotlin.$_$.aa;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var KtList = kotlin_kotlin.$_$.e7;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var KtMap = kotlin_kotlin.$_$.g7;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var toDouble = kotlin_kotlin.$_$.vl;
  var toDoubleOrNull = kotlin_kotlin.$_$.ul;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.y2;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var InlinePrimitiveDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w2;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var SEALED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var buildSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var SerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var ENUM_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var toLongOrNull = kotlin_kotlin.$_$.am;
  var toULongOrNull = kotlin_kotlin.$_$.hm;
  var ULong = kotlin_kotlin.$_$.zn;
  var Companion_getInstance = kotlin_kotlin.$_$.m3;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f1;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.x1;
  var toBooleanStrictOrNull = kotlin_kotlin.$_$.sl;
  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var isInterface = kotlin_kotlin.$_$.rg;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var lazy = kotlin_kotlin.$_$.to;
  var get_isNullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l1;
  var get_isInline = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k1;
  var get_annotations = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j1;
  var Encoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var CompositeEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var captureStack = kotlin_kotlin.$_$.gf;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x2;
  var SerializationException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
  var defineProp = kotlin_kotlin.$_$.pf;
  var fromInt = kotlin_kotlin.$_$.pe;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.n1;
  var UInt__toString_impl_dbgl21 = kotlin_kotlin.$_$.p1;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.w1;
  var ULong__toString_impl_f9au7k = kotlin_kotlin.$_$.z1;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.e1;
  var UByte__toString_impl_v72jg = kotlin_kotlin.$_$.g1;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.g2;
  var UShort__toString_impl_edaoee = kotlin_kotlin.$_$.i2;
  var ElementMarker = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var charSequenceSubSequence = kotlin_kotlin.$_$.mf;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var coerceAtMost = kotlin_kotlin.$_$.bi;
  var isBlank = kotlin_kotlin.$_$.dk;
  var Collection = kotlin_kotlin.$_$.y6;
  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var CLASS_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
  var toSet = kotlin_kotlin.$_$.uc;
  var jsonCachedSerialNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var singleOrNull = kotlin_kotlin.$_$.tb;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var getValue = kotlin_kotlin.$_$.u9;
  var copyOf = kotlin_kotlin.$_$.v8;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var LIST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
  var CONTEXTUAL_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var PolymorphicKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g1;
  var PrimitiveKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
  var MAP_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
  var ENUM = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
  var contextual = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p2;
  var SerializersModuleCollector = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q2;
  var DeepRecursiveFunction = kotlin_kotlin.$_$.cn;
  var invoke = kotlin_kotlin.$_$.mo;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var DeepRecursiveScope = kotlin_kotlin.$_$.dn;
  var Unit = kotlin_kotlin.$_$.co;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var AbstractDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var DeserializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s2;
  var getKClass = kotlin_kotlin.$_$.si;
  var findPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a3;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var substringBefore = kotlin_kotlin.$_$.ml;
  var removeSuffix = kotlin_kotlin.$_$.sk;
  var substringAfter = kotlin_kotlin.$_$.il;
  var contains = kotlin_kotlin.$_$.nj;
  var plus = kotlin_kotlin.$_$.vo;
  var missingFieldExceptionWithNewMessage = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l2;
  var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u2;
  var convertToByte = kotlin_kotlin.$_$.ke;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var convertToShort = kotlin_kotlin.$_$.me;
  var convertToInt = kotlin_kotlin.$_$.le;
  var IllegalArgumentException = kotlin_kotlin.$_$.hn;
  var isFinite = kotlin_kotlin.$_$.oo;
  var isFinite_0 = kotlin_kotlin.$_$.no;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var toUInt = kotlin_kotlin.$_$.fm;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.o1;
  var toULong = kotlin_kotlin.$_$.im;
  var toUByte = kotlin_kotlin.$_$.em;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.f1;
  var toUShort = kotlin_kotlin.$_$.jm;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.h2;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var AbstractEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var OBJECT_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
  var findPolymorphicSerializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b3;
  var SerializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y2;
  var toString_1 = kotlin_kotlin.$_$.y;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.l3;
  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.k3;
  var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.n3;
  var serializer_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c1;
  var setOf = kotlin_kotlin.$_$.sb;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var numberToChar = kotlin_kotlin.$_$.ah;
  var equals_0 = kotlin_kotlin.$_$.wj;
  var toByte = kotlin_kotlin.$_$.fh;
  var startsWith = kotlin_kotlin.$_$.dl;
  var NamedValueDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var numberRangeToNumber = kotlin_kotlin.$_$.yg;
  var ClosedRange = kotlin_kotlin.$_$.sh;
  var contains_0 = kotlin_kotlin.$_$.hi;
  var single = kotlin_kotlin.$_$.zk;
  var Char = kotlin_kotlin.$_$.ym;
  var emptySet = kotlin_kotlin.$_$.e9;
  var plus_0 = kotlin_kotlin.$_$.fb;
  var toInt = kotlin_kotlin.$_$.yl;
  var toList = kotlin_kotlin.$_$.kc;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var NamedValueEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f2;
  var enumEntries = kotlin_kotlin.$_$.ae;
  var getContextualDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var toNumber = kotlin_kotlin.$_$.bf;
  var last = kotlin_kotlin.$_$.na;
  var removeLast = kotlin_kotlin.$_$.ob;
  var lastIndexOf = kotlin_kotlin.$_$.nk;
  var Long = kotlin_kotlin.$_$.kn;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.t;
  var multiply = kotlin_kotlin.$_$.ue;
  var add = kotlin_kotlin.$_$.fe;
  var subtract = kotlin_kotlin.$_$.af;
  var compare = kotlin_kotlin.$_$.je;
  var numberToLong = kotlin_kotlin.$_$.we;
  var negate = kotlin_kotlin.$_$.ve;
  var charArray = kotlin_kotlin.$_$.if;
  var indexOf = kotlin_kotlin.$_$.bk;
  var indexOf_0 = kotlin_kotlin.$_$.ck;
  var substring = kotlin_kotlin.$_$.pl;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.v4;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.c4;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Json, 'Json', VOID, VOID, [StringFormat]);
  initMetadataForObject(Default, 'Default', VOID, Json);
  initMetadataForClass(JsonBuilder, 'JsonBuilder');
  initMetadataForClass(JsonImpl, 'JsonImpl', VOID, Json);
  initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
  initMetadataForClass(JsonIgnoreUnknownKeys, 'JsonIgnoreUnknownKeys');
  initMetadataForClass(JsonNames, 'JsonNames');
  initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
  initMetadataForClass(ClassDiscriminatorMode, 'ClassDiscriminatorMode', VOID, Enum);
  initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(JsonArray, 'JsonArray', VOID, JsonElement, [KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(JsonObject, 'JsonObject', VOID, JsonElement, [KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
  initMetadataForObject(JsonNull, 'JsonNull', VOID, JsonPrimitive, [SerializerFactory], VOID, VOID, {0: JsonNullSerializer_getInstance});
  initMetadataForClass(JsonLiteral, 'JsonLiteral', VOID, JsonPrimitive);
  initMetadataForClass(JsonObjectBuilder, 'JsonObjectBuilder');
  initMetadataForClass(JsonArrayBuilder, 'JsonArrayBuilder');
  initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
  initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForClass(JsonException, 'JsonException', VOID, SerializationException);
  initMetadataForClass(JsonDecodingException, 'JsonDecodingException', VOID, JsonException);
  initMetadataForClass(JsonEncodingException, 'JsonEncodingException', VOID, JsonException);
  initMetadataForClass(Composer, 'Composer');
  initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', VOID, Composer);
  initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', VOID, Composer);
  initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', VOID, Composer);
  initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
  initMetadataForObject(Tombstone, 'Tombstone');
  initMetadataForObject(RedactedKey, 'RedactedKey');
  initMetadataForClass(JsonPath, 'JsonPath');
  initMetadataForClass(JsonSerializersModuleValidator, 'JsonSerializersModuleValidator', VOID, VOID, [SerializersModuleCollector]);
  initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($readObjectCOROUTINE$, CoroutineImpl);
  initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [1]);
  initMetadataForClass(Key, 'Key', Key);
  initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
  initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
  initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, AbstractDecoder, [JsonDecoder]);
  initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', VOID, AbstractDecoder);
  initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, AbstractEncoder, [JsonEncoder]);
  initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, NamedValueDecoder, [JsonDecoder]);
  initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder', VOID, JsonTreeDecoder);
  initMetadataForClass(AbstractJsonTreeEncoder, 'AbstractJsonTreeEncoder', VOID, NamedValueEncoder, [JsonEncoder]);
  initMetadataForClass(JsonTreeEncoder, 'JsonTreeEncoder', VOID, AbstractJsonTreeEncoder);
  initMetadataForClass(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1, VOID, VOID, AbstractEncoder);
  initMetadataForClass(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1, VOID, VOID, AbstractEncoder);
  initMetadataForClass(JsonPrimitiveEncoder, 'JsonPrimitiveEncoder', VOID, AbstractJsonTreeEncoder);
  initMetadataForClass(JsonTreeListEncoder, 'JsonTreeListEncoder', VOID, AbstractJsonTreeEncoder);
  initMetadataForClass(JsonTreeMapEncoder, 'JsonTreeMapEncoder', VOID, JsonTreeEncoder);
  initMetadataForClass(WriteMode, 'WriteMode', VOID, Enum);
  initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
  initMetadataForObject(CharMappings, 'CharMappings');
  initMetadataForClass(StringJsonLexer, 'StringJsonLexer', VOID, AbstractJsonLexer);
  initMetadataForClass(StringJsonLexerWithComments, 'StringJsonLexerWithComments', VOID, StringJsonLexer);
  initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
  //endregion
  function Default() {
    Default_instance = this;
    Json.call(this, new JsonConfiguration(), EmptySerializersModule());
  }
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Json(configuration, serializersModule) {
    Default_getInstance();
    this.img_1 = configuration;
    this.jmg_1 = serializersModule;
    this.kmg_1 = new DescriptorSchemaCache();
  }
  protoOf(Json).c75 = function () {
    return this.jmg_1;
  };
  protoOf(Json).b72 = function (serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.r2v();
    }
  };
  protoOf(Json).c72 = function (deserializer, string) {
    var lexer = StringJsonLexer_0(this, string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.y70(), null);
    var result = input.m74(deserializer);
    lexer.cmh();
    return result;
  };
  protoOf(Json).lmg = function (serializer, value) {
    return writeJson(this, value, serializer);
  };
  protoOf(Json).mmg = function (deserializer, element) {
    return readJson(this, element, deserializer);
  };
  protoOf(Json).nmg = function (string) {
    return this.c72(JsonElementSerializer_getInstance(), string);
  };
  function Json_0(from, builderAction) {
    from = from === VOID ? Default_getInstance() : from;
    var builder = new JsonBuilder(from);
    builderAction(builder);
    var conf = builder.wmh();
    return new JsonImpl(conf, builder.umh_1);
  }
  function JsonBuilder(json) {
    this.dmh_1 = json.img_1.xmh_1;
    this.emh_1 = json.img_1.cmi_1;
    this.fmh_1 = json.img_1.ymh_1;
    this.gmh_1 = json.img_1.zmh_1;
    this.hmh_1 = json.img_1.bmi_1;
    this.imh_1 = json.img_1.dmi_1;
    this.jmh_1 = json.img_1.emi_1;
    this.kmh_1 = json.img_1.gmi_1;
    this.lmh_1 = json.img_1.nmi_1;
    this.mmh_1 = json.img_1.imi_1;
    this.nmh_1 = json.img_1.jmi_1;
    this.omh_1 = json.img_1.kmi_1;
    this.pmh_1 = json.img_1.lmi_1;
    this.qmh_1 = json.img_1.mmi_1;
    this.rmh_1 = json.img_1.hmi_1;
    this.smh_1 = json.img_1.ami_1;
    this.tmh_1 = json.img_1.fmi_1;
    this.umh_1 = json.c75();
    this.vmh_1 = json.img_1.omi_1;
  }
  protoOf(JsonBuilder).wmh = function () {
    if (this.tmh_1) {
      // Inline function 'kotlin.require' call
      if (!(this.kmh_1 === 'type')) {
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.require' call
      if (!this.lmh_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
        var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
    }
    if (!this.hmh_1) {
      // Inline function 'kotlin.require' call
      if (!(this.imh_1 === '    ')) {
        var message_1 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }
    } else if (!(this.imh_1 === '    ')) {
      var tmp0 = this.imh_1;
      var tmp$ret$6;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(tmp0)) {
          var element = charSequenceGet(tmp0, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$6 = false;
            break $l$block;
          }
        }
        tmp$ret$6 = true;
      }
      var allWhitespaces = tmp$ret$6;
      // Inline function 'kotlin.require' call
      if (!allWhitespaces) {
        var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.imh_1;
        throw IllegalArgumentException_init_$Create$(toString(message_2));
      }
    }
    return new JsonConfiguration(this.dmh_1, this.fmh_1, this.gmh_1, this.smh_1, this.hmh_1, this.emh_1, this.imh_1, this.jmh_1, this.tmh_1, this.kmh_1, this.rmh_1, this.mmh_1, this.nmh_1, this.omh_1, this.pmh_1, this.qmh_1, this.lmh_1, this.vmh_1);
  };
  function validateConfiguration($this) {
    if (equals($this.c75(), EmptySerializersModule()))
      return Unit_instance;
    var collector = new JsonSerializersModuleValidator($this.img_1);
    $this.c75().p7l(collector);
  }
  function JsonImpl(configuration, module_0) {
    Json.call(this, configuration, module_0);
    validateConfiguration(this);
  }
  function JsonClassDiscriminator() {
  }
  function JsonIgnoreUnknownKeys() {
  }
  function JsonNames() {
  }
  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode, exceptionsWithDebugInfo) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
    allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
    allowComments = allowComments === VOID ? false : allowComments;
    classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
    exceptionsWithDebugInfo = exceptionsWithDebugInfo === VOID ? true : exceptionsWithDebugInfo;
    this.xmh_1 = encodeDefaults;
    this.ymh_1 = ignoreUnknownKeys;
    this.zmh_1 = isLenient;
    this.ami_1 = allowStructuredMapKeys;
    this.bmi_1 = prettyPrint;
    this.cmi_1 = explicitNulls;
    this.dmi_1 = prettyPrintIndent;
    this.emi_1 = coerceInputValues;
    this.fmi_1 = useArrayPolymorphism;
    this.gmi_1 = classDiscriminator;
    this.hmi_1 = allowSpecialFloatingPointValues;
    this.imi_1 = useAlternativeNames;
    this.jmi_1 = namingStrategy;
    this.kmi_1 = decodeEnumsCaseInsensitive;
    this.lmi_1 = allowTrailingComma;
    this.mmi_1 = allowComments;
    this.nmi_1 = classDiscriminatorMode;
    this.omi_1 = exceptionsWithDebugInfo;
  }
  protoOf(JsonConfiguration).toString = function () {
    return 'JsonConfiguration(encodeDefaults=' + this.xmh_1 + ', ignoreUnknownKeys=' + this.ymh_1 + ', isLenient=' + this.zmh_1 + ', ' + ('allowStructuredMapKeys=' + this.ami_1 + ', prettyPrint=' + this.bmi_1 + ', explicitNulls=' + this.cmi_1 + ', ') + ("prettyPrintIndent='" + this.dmi_1 + "', coerceInputValues=" + this.emi_1 + ', useArrayPolymorphism=' + this.fmi_1 + ', ') + ("classDiscriminator='" + this.gmi_1 + "', allowSpecialFloatingPointValues=" + this.hmi_1 + ', ') + ('useAlternativeNames=' + this.imi_1 + ', namingStrategy=' + toString_0(this.jmi_1) + ', decodeEnumsCaseInsensitive=' + this.kmi_1 + ', ') + ('allowTrailingComma=' + this.lmi_1 + ', allowComments=' + this.mmi_1 + ', classDiscriminatorMode=' + this.nmi_1.toString() + ', exceptionsWithDebugInfo=' + this.omi_1 + ')');
  };
  var ClassDiscriminatorMode_NONE_instance;
  var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
  var ClassDiscriminatorMode_POLYMORPHIC_instance;
  var ClassDiscriminatorMode_entriesInitialized;
  function ClassDiscriminatorMode_initEntries() {
    if (ClassDiscriminatorMode_entriesInitialized)
      return Unit_instance;
    ClassDiscriminatorMode_entriesInitialized = true;
    ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
    ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
    ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
  }
  function ClassDiscriminatorMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ClassDiscriminatorMode_NONE_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_NONE_instance;
  }
  function ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
  }
  function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_POLYMORPHIC_instance;
  }
  function JsonDecoder() {
  }
  function get_jsonUnquotedLiteralDescriptor() {
    _init_properties_JsonElement_kt__7cbdc2();
    return jsonUnquotedLiteralDescriptor;
  }
  var jsonUnquotedLiteralDescriptor;
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance_3() {
    return Companion_instance;
  }
  function JsonElement() {
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_4() {
    return Companion_instance_0;
  }
  function JsonArray(content) {
    JsonElement.call(this);
    this.rmi_1 = content;
  }
  protoOf(JsonArray).equals = function (other) {
    return equals(this.rmi_1, other);
  };
  protoOf(JsonArray).hashCode = function () {
    return hashCode(this.rmi_1);
  };
  protoOf(JsonArray).toString = function () {
    return joinToString(this.rmi_1, ',', '[', ']');
  };
  protoOf(JsonArray).r = function () {
    return this.rmi_1.r();
  };
  protoOf(JsonArray).smi = function (element) {
    return this.rmi_1.m1(element);
  };
  protoOf(JsonArray).m1 = function (element) {
    if (!(element instanceof JsonElement))
      return false;
    return this.smi(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray).t = function () {
    return this.rmi_1.t();
  };
  protoOf(JsonArray).tmi = function (elements) {
    return this.rmi_1.r2(elements);
  };
  protoOf(JsonArray).r2 = function (elements) {
    return this.tmi(elements);
  };
  protoOf(JsonArray).l1 = function (index) {
    return this.rmi_1.l1(index);
  };
  protoOf(JsonArray).umi = function (element) {
    return this.rmi_1.q1(element);
  };
  protoOf(JsonArray).q1 = function (element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.umi(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray).p1 = function (index) {
    return this.rmi_1.p1(index);
  };
  protoOf(JsonArray).t2 = function (fromIndex, toIndex) {
    return this.rmi_1.t2(fromIndex, toIndex);
  };
  protoOf(JsonArray).n1 = function () {
    return this.rmi_1.n1();
  };
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_5() {
    return Companion_instance_1;
  }
  function JsonPrimitive() {
    JsonElement.call(this);
  }
  protoOf(JsonPrimitive).toString = function () {
    return this.rj3();
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_6() {
    return Companion_instance_2;
  }
  function JsonObject$toString$lambda(_destruct__k2r9zo) {
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.t1();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.u1();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    printQuoted(this_0, k);
    this_0.s(_Char___init__impl__6a9atx(58));
    this_0.w(v);
    return this_0.toString();
  }
  function JsonObject(content) {
    JsonElement.call(this);
    this.wmi_1 = content;
  }
  protoOf(JsonObject).equals = function (other) {
    return equals(this.wmi_1, other);
  };
  protoOf(JsonObject).hashCode = function () {
    return hashCode(this.wmi_1);
  };
  protoOf(JsonObject).toString = function () {
    var tmp = this.wmi_1.s1();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  };
  protoOf(JsonObject).r = function () {
    return this.wmi_1.r();
  };
  protoOf(JsonObject).xmi = function (key) {
    return this.wmi_1.u2(key);
  };
  protoOf(JsonObject).u2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.xmi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).ymi = function (value) {
    return this.wmi_1.v2(value);
  };
  protoOf(JsonObject).v2 = function (value) {
    if (!(value instanceof JsonElement))
      return false;
    return this.ymi(value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonObject).je = function (key) {
    return this.wmi_1.w2(key);
  };
  protoOf(JsonObject).w2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.je((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).n1 = function () {
    return this.wmi_1.n1();
  };
  protoOf(JsonObject).x2 = function () {
    return this.wmi_1.x2();
  };
  protoOf(JsonObject).y2 = function () {
    return this.wmi_1.y2();
  };
  protoOf(JsonObject).s1 = function () {
    return this.wmi_1.s1();
  };
  function JsonNull() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this.zmi_1 = 'null';
  }
  protoOf(JsonNull).vmi = function () {
    return false;
  };
  protoOf(JsonNull).rj3 = function () {
    return this.zmi_1;
  };
  protoOf(JsonNull).amj = function () {
    return JsonNullSerializer_getInstance();
  };
  protoOf(JsonNull).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull();
    return JsonNull_instance;
  }
  function JsonLiteral(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    JsonPrimitive.call(this);
    this.bmj_1 = isString;
    this.cmj_1 = coerceToInlineType;
    this.dmj_1 = toString(body);
    if (!(this.cmj_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!this.cmj_1.v72()) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  protoOf(JsonLiteral).vmi = function () {
    return this.bmj_1;
  };
  protoOf(JsonLiteral).rj3 = function () {
    return this.dmj_1;
  };
  protoOf(JsonLiteral).toString = function () {
    var tmp;
    if (this.bmj_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$();
      printQuoted(this_0, this.dmj_1);
      tmp = this_0.toString();
    } else {
      tmp = this.dmj_1;
    }
    return tmp;
  };
  protoOf(JsonLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.bmj_1 === other.bmj_1))
      return false;
    if (!(this.dmj_1 === other.dmj_1))
      return false;
    return true;
  };
  protoOf(JsonLiteral).hashCode = function () {
    var result = getBooleanHashCode(this.bmj_1);
    result = imul(31, result) + getStringHashCode(this.dmj_1) | 0;
    return result;
  };
  function get_jsonPrimitive(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error(_this__u8e3s4, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function get_contentOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp;
    if (_this__u8e3s4 instanceof JsonNull) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4.rj3();
    }
    return tmp;
  }
  function get_booleanOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toBooleanStrictOrNull_0(_this__u8e3s4.rj3());
  }
  function parseLongImpl(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return StringJsonLexer_0(Default_getInstance(), _this__u8e3s4.rj3()).emj();
  }
  function get_float(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlin.text.toFloat' call
    var this_0 = _this__u8e3s4.rj3();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return toDouble(this_0);
  }
  function get_double(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDouble(_this__u8e3s4.rj3());
  }
  function JsonPrimitive_0(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function JsonPrimitive_1(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function JsonPrimitive_2(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function error(_this__u8e3s4, element) {
    _init_properties_JsonElement_kt__7cbdc2();
    throw IllegalArgumentException_init_$Create$('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
  }
  function get_jsonObject(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonObject ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error(_this__u8e3s4, 'JsonObject');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function get_doubleOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDoubleOrNull(_this__u8e3s4.rj3());
  }
  function get_jsonArray(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonArray ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error(_this__u8e3s4, 'JsonArray');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  var properties_initialized_JsonElement_kt_abxy8s;
  function _init_properties_JsonElement_kt__7cbdc2() {
    if (!properties_initialized_JsonElement_kt_abxy8s) {
      properties_initialized_JsonElement_kt_abxy8s = true;
      jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
    }
  }
  function JsonObjectBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.fmj_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonObjectBuilder).gmj = function (key, element) {
    return this.fmj_1.z2(key, element);
  };
  protoOf(JsonObjectBuilder).wmh = function () {
    return new JsonObject(this.fmj_1);
  };
  function put(_this__u8e3s4, key, value) {
    return _this__u8e3s4.gmj(key, JsonPrimitive_0(value));
  }
  function put_0(_this__u8e3s4, key, value) {
    return _this__u8e3s4.gmj(key, JsonPrimitive_2(value));
  }
  function put_1(_this__u8e3s4, key, value) {
    return _this__u8e3s4.gmj(key, JsonPrimitive_1(value));
  }
  function putJsonObject(_this__u8e3s4, key, builderAction) {
    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
    var builder = new JsonObjectBuilder();
    builderAction(builder);
    var tmp$ret$0 = builder.wmh();
    return _this__u8e3s4.gmj(key, tmp$ret$0);
  }
  function putJsonArray(_this__u8e3s4, key, builderAction) {
    // Inline function 'kotlinx.serialization.json.buildJsonArray' call
    var builder = new JsonArrayBuilder();
    builderAction(builder);
    var tmp$ret$0 = builder.wmh();
    return _this__u8e3s4.gmj(key, tmp$ret$0);
  }
  function JsonArrayBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.hmj_1 = ArrayList_init_$Create$();
  }
  protoOf(JsonArrayBuilder).imj = function (element) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.hmj_1.j1(element);
    return true;
  };
  protoOf(JsonArrayBuilder).wmh = function () {
    return new JsonArray(this.hmj_1);
  };
  function add_0(_this__u8e3s4, value) {
    return _this__u8e3s4.imj(JsonPrimitive_0(value));
  }
  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.m71('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
    $this$buildSerialDescriptor.m71('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
    $this$buildSerialDescriptor.m71('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
    $this$buildSerialDescriptor.m71('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
    $this$buildSerialDescriptor.m71('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
    return Unit_instance;
  }
  function JsonElementSerializer$descriptor$lambda$lambda() {
    return JsonPrimitiveSerializer_getInstance().jmj_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_0() {
    return JsonNullSerializer_getInstance().kmj_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_1() {
    return JsonLiteralSerializer_getInstance().lmj_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_2() {
    return JsonObjectSerializer_getInstance().mmj_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_3() {
    return JsonArraySerializer_getInstance().nmj_1;
  }
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.omj_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  protoOf(JsonElementSerializer).y70 = function () {
    return this.omj_1;
  };
  protoOf(JsonElementSerializer).pmj = function (encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.f76(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject) {
        encoder.f76(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray) {
          encoder.f76(JsonArraySerializer_getInstance(), value);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  };
  protoOf(JsonElementSerializer).z70 = function (encoder, value) {
    return this.pmj(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonElementSerializer).a71 = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.qmi();
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    this.qmj_1 = ListSerializer(JsonElementSerializer_getInstance()).y70();
    this.rmj_1 = 'kotlinx.serialization.json.JsonArray';
  }
  protoOf(JsonArrayDescriptor).z71 = function () {
    return this.rmj_1;
  };
  protoOf(JsonArrayDescriptor).y72 = function (index) {
    return this.qmj_1.y72(index);
  };
  protoOf(JsonArrayDescriptor).z72 = function (name) {
    return this.qmj_1.z72(name);
  };
  protoOf(JsonArrayDescriptor).a73 = function (index) {
    return this.qmj_1.a73(index);
  };
  protoOf(JsonArrayDescriptor).b73 = function (index) {
    return this.qmj_1.b73(index);
  };
  protoOf(JsonArrayDescriptor).c73 = function (index) {
    return this.qmj_1.c73(index);
  };
  protoOf(JsonArrayDescriptor).u72 = function () {
    return this.qmj_1.u72();
  };
  protoOf(JsonArrayDescriptor).n72 = function () {
    return this.qmj_1.n72();
  };
  protoOf(JsonArrayDescriptor).v72 = function () {
    return this.qmj_1.v72();
  };
  protoOf(JsonArrayDescriptor).w72 = function () {
    return this.qmj_1.w72();
  };
  protoOf(JsonArrayDescriptor).x72 = function () {
    return this.qmj_1.x72();
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this.nmj_1 = JsonArrayDescriptor_getInstance();
  }
  protoOf(JsonArraySerializer).y70 = function () {
    return this.nmj_1;
  };
  protoOf(JsonArraySerializer).smj = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).z70(encoder, value);
  };
  protoOf(JsonArraySerializer).z70 = function (encoder, value) {
    return this.smj(encoder, value instanceof JsonArray ? value : THROW_CCE());
  };
  protoOf(JsonArraySerializer).a71 = function (decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).a71(decoder));
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    this.jmj_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  protoOf(JsonPrimitiveSerializer).y70 = function () {
    return this.jmj_1;
  };
  protoOf(JsonPrimitiveSerializer).tmj = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.f76(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.f76(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(JsonPrimitiveSerializer).z70 = function (encoder, value) {
    return this.tmj(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  protoOf(JsonPrimitiveSerializer).a71 = function (decoder) {
    var jsonDecoder = asJsonDecoder(decoder);
    var result = jsonDecoder.qmi();
    if (!(result instanceof JsonPrimitive)) {
      // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
      var shortMessage = 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result));
      var tmp;
      if (jsonDecoder.pmi().img_1.omi_1) {
        var tmp$ret$3 = toString(result);
        tmp = toString(minify(tmp$ret$3));
      } else {
        tmp = null;
      }
      var inputValue = tmp;
      throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue), shortMessage, -1, null, inputValue, null);
    }
    return result;
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function defer(deferred) {
    return new defer$1(deferred);
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    this.kmj_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  protoOf(JsonNullSerializer).y70 = function () {
    return this.kmj_1;
  };
  protoOf(JsonNullSerializer).umj = function (encoder, value) {
    verify(encoder);
    encoder.i75();
  };
  protoOf(JsonNullSerializer).z70 = function (encoder, value) {
    return this.umj(encoder, value instanceof JsonNull ? value : THROW_CCE());
  };
  protoOf(JsonNullSerializer).a71 = function (decoder) {
    verify_0(decoder);
    if (decoder.y73()) {
      throw decodingExceptionOf("Expected 'null' literal");
    }
    decoder.z73();
    return JsonNull_getInstance();
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this.lmj_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  protoOf(JsonLiteralSerializer).y70 = function () {
    return this.lmj_1;
  };
  protoOf(JsonLiteralSerializer).vmj = function (encoder, value) {
    verify(encoder);
    if (value.bmj_1) {
      return encoder.r75(value.dmj_1);
    }
    if (!(value.cmj_1 == null)) {
      return encoder.t75(value.cmj_1).r75(value.dmj_1);
    }
    var tmp0_safe_receiver = toLongOrNull(value.dmj_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.n75(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.dmj_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp1_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).ss_1;
      var tmp_1 = encoder.t75(serializer_0(Companion_getInstance()).y70());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$4 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.n75(tmp$ret$4);
      return Unit_instance;
    }
    var tmp2_safe_receiver = toDoubleOrNull(value.dmj_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.p75(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = toBooleanStrictOrNull(value.dmj_1);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.j75(tmp3_safe_receiver);
    }
    encoder.r75(value.dmj_1);
  };
  protoOf(JsonLiteralSerializer).z70 = function (encoder, value) {
    return this.vmj(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  protoOf(JsonLiteralSerializer).a71 = function (decoder) {
    var jsonDecoder = asJsonDecoder(decoder);
    var result = jsonDecoder.qmi();
    if (!(result instanceof JsonLiteral)) {
      // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
      var shortMessage = 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result));
      var tmp;
      if (jsonDecoder.pmi().img_1.omi_1) {
        var tmp$ret$3 = toString(result);
        tmp = toString(minify(tmp$ret$3));
      } else {
        tmp = null;
      }
      var inputValue = tmp;
      throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue), shortMessage, -1, null, inputValue, null);
    }
    return result;
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    this.wmj_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).y70();
    this.xmj_1 = 'kotlinx.serialization.json.JsonObject';
  }
  protoOf(JsonObjectDescriptor).z71 = function () {
    return this.xmj_1;
  };
  protoOf(JsonObjectDescriptor).y72 = function (index) {
    return this.wmj_1.y72(index);
  };
  protoOf(JsonObjectDescriptor).z72 = function (name) {
    return this.wmj_1.z72(name);
  };
  protoOf(JsonObjectDescriptor).a73 = function (index) {
    return this.wmj_1.a73(index);
  };
  protoOf(JsonObjectDescriptor).b73 = function (index) {
    return this.wmj_1.b73(index);
  };
  protoOf(JsonObjectDescriptor).c73 = function (index) {
    return this.wmj_1.c73(index);
  };
  protoOf(JsonObjectDescriptor).u72 = function () {
    return this.wmj_1.u72();
  };
  protoOf(JsonObjectDescriptor).n72 = function () {
    return this.wmj_1.n72();
  };
  protoOf(JsonObjectDescriptor).v72 = function () {
    return this.wmj_1.v72();
  };
  protoOf(JsonObjectDescriptor).w72 = function () {
    return this.wmj_1.w72();
  };
  protoOf(JsonObjectDescriptor).x72 = function () {
    return this.wmj_1.x72();
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this.mmj_1 = JsonObjectDescriptor_getInstance();
  }
  protoOf(JsonObjectSerializer).y70 = function () {
    return this.mmj_1;
  };
  protoOf(JsonObjectSerializer).ymj = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).z70(encoder, value);
  };
  protoOf(JsonObjectSerializer).z70 = function (encoder, value) {
    return this.ymj(encoder, value instanceof JsonObject ? value : THROW_CCE());
  };
  protoOf(JsonObjectSerializer).a71 = function (decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).a71(decoder));
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
  }
  function asJsonDecoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function verify_0(decoder) {
    asJsonDecoder(decoder);
  }
  function asJsonEncoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original__l7ku1m($this) {
    var tmp0 = $this.zmj_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('original', 1, tmp, defer$o$_get_original_$ref_3cje7k(), null);
    return tmp0.u1();
  }
  function defer$o$_get_original_$ref_3cje7k() {
    return constructCallableReference(function (p0) {
      return _get_original__l7ku1m(p0);
    }, 1, 0, 389);
  }
  function defer$1($deferred) {
    this.zmj_1 = lazy($deferred);
  }
  protoOf(defer$1).z71 = function () {
    return _get_original__l7ku1m(this).z71();
  };
  protoOf(defer$1).u72 = function () {
    return _get_original__l7ku1m(this).u72();
  };
  protoOf(defer$1).w72 = function () {
    return _get_original__l7ku1m(this).w72();
  };
  protoOf(defer$1).y72 = function (index) {
    return _get_original__l7ku1m(this).y72(index);
  };
  protoOf(defer$1).z72 = function (name) {
    return _get_original__l7ku1m(this).z72(name);
  };
  protoOf(defer$1).a73 = function (index) {
    return _get_original__l7ku1m(this).a73(index);
  };
  protoOf(defer$1).b73 = function (index) {
    return _get_original__l7ku1m(this).b73(index);
  };
  protoOf(defer$1).c73 = function (index) {
    return _get_original__l7ku1m(this).c73(index);
  };
  function JsonEncoder() {
  }
  function JsonDecodingException(fullMessage, shortMessage, offset, path, input, hint) {
    JsonException.call(this, fullMessage);
    captureStack(this, JsonDecodingException);
    this.cmk_1 = shortMessage;
    this.dmk_1 = offset;
    this.emk_1 = path;
    this.fmk_1 = input;
    this.gmk_1 = hint;
  }
  function JsonException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, JsonException);
    this.hmk_1 = message;
    delete this.message;
  }
  protoOf(JsonException).e = function () {
    return this.hmk_1;
  };
  function JsonEncodingException(shortMessage, classSerialName, hint) {
    classSerialName = classSerialName === VOID ? null : classSerialName;
    hint = hint === VOID ? null : hint;
    JsonException.call(this, formatEncodingException(shortMessage, hint));
    captureStack(this, JsonEncodingException);
    this.jmk_1 = shortMessage;
    this.kmk_1 = classSerialName;
    this.lmk_1 = hint;
  }
  function Composer(writer) {
    this.mmk_1 = writer;
    this.nmk_1 = true;
  }
  protoOf(Composer).omk = function () {
    this.nmk_1 = true;
  };
  protoOf(Composer).pmk = function () {
    return Unit_instance;
  };
  protoOf(Composer).qmk = function () {
    this.nmk_1 = false;
  };
  protoOf(Composer).rmk = function () {
    this.nmk_1 = false;
  };
  protoOf(Composer).smk = function () {
    return Unit_instance;
  };
  protoOf(Composer).tmk = function (v) {
    return this.mmk_1.umk(v);
  };
  protoOf(Composer).vmk = function (v) {
    return this.mmk_1.wmk(v);
  };
  protoOf(Composer).xmk = function (v) {
    return this.mmk_1.wmk(v.toString());
  };
  protoOf(Composer).ymk = function (v) {
    return this.mmk_1.wmk(v.toString());
  };
  protoOf(Composer).zmk = function (v) {
    return this.mmk_1.aml(fromInt(v));
  };
  protoOf(Composer).bml = function (v) {
    return this.mmk_1.aml(fromInt(v));
  };
  protoOf(Composer).cml = function (v) {
    return this.mmk_1.aml(fromInt(v));
  };
  protoOf(Composer).dml = function (v) {
    return this.mmk_1.aml(v);
  };
  protoOf(Composer).eml = function (v) {
    return this.mmk_1.wmk(v.toString());
  };
  protoOf(Composer).fml = function (value) {
    return this.mmk_1.gml(value);
  };
  function Composer_0(sb, json) {
    return json.img_1.bmi_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
  }
  function ComposerForUnsignedNumbers(writer, forceQuoting) {
    Composer.call(this, writer);
    this.jml_1 = forceQuoting;
  }
  protoOf(ComposerForUnsignedNumbers).cml = function (v) {
    if (this.jml_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.fml(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.vmk(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).dml = function (v) {
    if (this.jml_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.fml(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.vmk(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).zmk = function (v) {
    if (this.jml_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.fml(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.vmk(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).bml = function (v) {
    if (this.jml_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.fml(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.vmk(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  };
  function ComposerForUnquotedLiterals(writer, forceQuoting) {
    Composer.call(this, writer);
    this.mml_1 = forceQuoting;
  }
  protoOf(ComposerForUnquotedLiterals).fml = function (value) {
    if (this.mml_1) {
      protoOf(Composer).fml.call(this, value);
    } else {
      protoOf(Composer).vmk.call(this, value);
    }
  };
  function ComposerWithPrettyPrint(writer, json) {
    Composer.call(this, writer);
    this.pml_1 = json;
    this.qml_1 = 0;
  }
  protoOf(ComposerWithPrettyPrint).omk = function () {
    this.nmk_1 = true;
    this.qml_1 = this.qml_1 + 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).pmk = function () {
    this.qml_1 = this.qml_1 - 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).qmk = function () {
    this.nmk_1 = false;
    this.vmk('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.qml_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.vmk(this.pml_1.img_1.dmi_1);
      }
       while (inductionVariable < times);
  };
  protoOf(ComposerWithPrettyPrint).rmk = function () {
    if (this.nmk_1)
      this.nmk_1 = false;
    else {
      this.qmk();
    }
  };
  protoOf(ComposerWithPrettyPrint).smk = function () {
    this.tmk(_Char___init__impl__6a9atx(32));
  };
  function readIfAbsent($this, descriptor, index) {
    $this.sml_1 = (!descriptor.c73(index) && descriptor.b73(index).n72());
    return $this.sml_1;
  }
  function JsonElementMarker$readIfAbsent$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      var tmp0 = p0;
      return readIfAbsent(tmp0, p0_0, p1);
    }, 2, 0, 390, 'readIfAbsent', [p0]);
  }
  function JsonElementMarker(descriptor) {
    var tmp = this;
    tmp.rml_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.sml_1 = false;
  }
  protoOf(JsonElementMarker).tml = function (index) {
    this.rml_1.u7a(index);
  };
  protoOf(JsonElementMarker).uml = function () {
    return this.rml_1.v7a();
  };
  function minify(_this__u8e3s4, offset) {
    offset = offset === VOID ? -1 : offset;
    if (charSequenceLength(_this__u8e3s4) < 200)
      return _this__u8e3s4;
    if (offset === -1) {
      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
      if (start <= 0)
        return _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var endIndex = charSequenceLength(_this__u8e3s4);
      return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
    }
    var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
    var tmp2 = coerceAtLeast(start_0, 0);
    // Inline function 'kotlin.text.substring' call
    var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
    return prefix + toString(charSequenceSubSequence(_this__u8e3s4, tmp2, endIndex_0)) + suffix;
  }
  function access$formatDecodingException$tJsonExceptionsKt(offset, shortMessage, path, hint, input) {
    return formatDecodingException(offset, shortMessage, path, hint, input);
  }
  function decodingExceptionOf(shortMessage) {
    return new JsonDecodingException(formatDecodingException(-1, shortMessage, null, null, null), shortMessage, -1, null, null, null);
  }
  function formatDecodingException(offset, shortMessage, path, hint, input) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    if (offset >= 0) {
      this_0.q('Unexpected JSON token at offset ' + offset + ': ');
    }
    this_0.q(shortMessage);
    // Inline function 'kotlin.text.isNullOrBlank' call
    if (!(path == null || isBlank(path))) {
      this_0.q(' at path: ');
      this_0.q(path);
    }
    // Inline function 'kotlin.text.isNullOrBlank' call
    if (!(hint == null || isBlank(hint))) {
      this_0.q('\n' + hint);
    }
    if (!(input == null)) {
      this_0.q('\nJSON input: ');
      this_0.q(input);
    }
    return this_0.toString();
  }
  function invalidTrailingComma(_this__u8e3s4, entity) {
    entity = entity === VOID ? 'object' : entity;
    _this__u8e3s4.vml('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.ymg_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingComma = true' in 'Json {}' builder to support them.");
  }
  function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
    _this__u8e3s4.wml(nonFiniteFpMessage(result, null), VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
  }
  function InvalidFloatingPointEncoded(value, key) {
    key = key === VOID ? null : key;
    return new JsonEncodingException(nonFiniteFpMessage(value, key), VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException("Value of type '" + keyDescriptor.z71() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.u72().toString() + "'"), keyDescriptor.z71(), "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
  }
  function access$nonFiniteFpMessage$tJsonExceptionsKt(value, key) {
    return nonFiniteFpMessage(value, key);
  }
  function decodingExceptionOf_0(_this__u8e3s4, shortMessage, offset, path, hint, input) {
    // Inline function 'kotlinx.serialization.json.internal.ifDebugInput' call
    var tmp;
    if (_this__u8e3s4.xmg_1.omi_1) {
      tmp = toString(minify(input, offset));
    } else {
      tmp = null;
    }
    var inputValue = tmp;
    return new JsonDecodingException(formatDecodingException(offset, shortMessage, path, hint, inputValue), shortMessage, offset, path, inputValue, hint);
  }
  function formatEncodingException(shortMessage, hint) {
    var tmp;
    // Inline function 'kotlin.text.isNullOrBlank' call
    if (hint == null || isBlank(hint)) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    return shortMessage + tmp;
  }
  function nonFiniteFpMessage(value, key) {
    return 'Unexpected special floating-point value ' + toString(value) + (!(key == null) ? ' with key ' + key + '. ' : '. ') + 'By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification.';
  }
  function get_JsonDeserializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonDeserializationNamesKey;
  }
  var JsonDeserializationNamesKey;
  function get_JsonSerializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonSerializationNamesKey;
  }
  var JsonSerializationNamesKey;
  function ignoreUnknownKeys(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp;
    if (json.img_1.ymh_1) {
      tmp = true;
    } else {
      var tmp0 = _this__u8e3s4.x72();
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (element instanceof JsonIgnoreUnknownKeys) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  function getJsonNameIndex(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    if (decodeCaseInsensitive(json, _this__u8e3s4)) {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = name.toLowerCase();
      return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$0);
    }
    var strategy = namingStrategy(_this__u8e3s4, json);
    if (!(strategy == null))
      return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
    var index = _this__u8e3s4.z72(name);
    if (!(index === -3))
      return index;
    if (!json.img_1.imi_1)
      return index;
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  }
  function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
    suffix = suffix === VOID ? '' : suffix;
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var index = getJsonNameIndex(_this__u8e3s4, json, name);
    if (index === -3)
      throw SerializationException_init_$Create$(_this__u8e3s4.z71() + " does not contain element with name '" + name + "'" + suffix);
    return index;
  }
  function getJsonElementName(_this__u8e3s4, json, index) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? _this__u8e3s4.y72(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
  }
  function namingStrategy(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return equals(_this__u8e3s4.u72(), CLASS_getInstance()) ? json.img_1.jmi_1 : null;
  }
  function deserializationNamesMap(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(_this__u8e3s4);
    var tmp_0 = get_JsonDeserializationNamesKey();
    return tmp.yml(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
  }
  function getJsonEncodedNames(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? jsonCachedSerialNames(_this__u8e3s4) : toSet(serializationNamesIndices(_this__u8e3s4, json, strategy));
  }
  function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return _this__u8e3s4.img_1.kmi_1 && equals(descriptor.u72(), ENUM_getInstance());
  }
  function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).w2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  function serializationNamesIndices(_this__u8e3s4, json, strategy) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(json);
    var tmp_0 = get_JsonSerializationNamesKey();
    return tmp.yml(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
  }
  function buildDeserializationNamesMap(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var builder = LinkedHashMap_init_$Create$();
    var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
    var strategyForClasses = namingStrategy(_this__u8e3s4, json);
    var inductionVariable = 0;
    var last = _this__u8e3s4.w72();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.filterIsInstance' call
        var tmp0 = _this__u8e3s4.a73(i);
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var destination = ArrayList_init_$Create$();
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (element instanceof JsonNames) {
            destination.j1(element);
          }
        }
        var tmp0_safe_receiver = singleOrNull(destination);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zml_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable_0 = 0;
          var last_0 = tmp1_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = tmp1_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp;
            if (useLowercaseEnums) {
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp = element_0.toLowerCase();
            } else {
              tmp = element_0;
            }
            buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
          }
        }
        var tmp_0;
        if (useLowercaseEnums) {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = _this__u8e3s4.y72(i).toLowerCase();
        } else if (!(strategyForClasses == null)) {
          tmp_0 = strategyForClasses.amm(_this__u8e3s4, i, _this__u8e3s4.y72(i));
        } else {
          tmp_0 = null;
        }
        var nameToPut = tmp_0;
        if (nameToPut == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp_1;
    if (builder.r()) {
      tmp_1 = emptyMap();
    } else {
      tmp_1 = builder;
    }
    return tmp_1;
  }
  function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
    return function () {
      return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
    };
  }
  function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
    return function () {
      // Inline function 'kotlin.collections.mutableSetOf' call
      var trackingSet = LinkedHashSet_init_$Create$();
      var tmp = 0;
      var tmp_0 = $this_serializationNamesIndices.w72();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = Array(tmp_0);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var baseName = $this_serializationNamesIndices.y72(tmp_2);
        var name = $strategy.amm($this_serializationNamesIndices, tmp_2, baseName);
        if (!trackingSet.j1(name))
          throw new JsonEncodingException("The transformed name '" + name + "' for property " + baseName + ' already exists ' + ('in ' + toString($this_serializationNamesIndices)), $this_serializationNamesIndices.z71());
        tmp_1[tmp_2] = name;
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
    var entity = equals($this_buildDeserializationNamesMap.u72(), ENUM_getInstance()) ? 'enum value' : 'property';
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).u2(name)) {
      throw decodingExceptionOf("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.y72(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.y72(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
    }
    // Inline function 'kotlin.collections.set' call
    _this__u8e3s4.z2(name, index);
  }
  var properties_initialized_JsonNamesMap_kt_ljpf42;
  function _init_properties_JsonNamesMap_kt__cbbp0k() {
    if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
      JsonDeserializationNamesKey = new Key();
      JsonSerializationNamesKey = new Key();
    }
  }
  function Tombstone() {
  }
  var Tombstone_instance;
  function Tombstone_getInstance() {
    return Tombstone_instance;
  }
  function RedactedKey() {
  }
  var RedactedKey_instance;
  function RedactedKey_getInstance() {
    return RedactedKey_instance;
  }
  function resize($this) {
    var newSize = imul($this.emm_1, 2);
    $this.cmm_1 = copyOf($this.cmm_1, newSize);
    var tmp = 0;
    var tmp_0 = new Int32Array(newSize);
    while (tmp < newSize) {
      tmp_0[tmp] = -1;
      tmp = tmp + 1 | 0;
    }
    var newIndices = tmp_0;
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = $this.dmm_1;
    var endIndex = this_0.length;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = this_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp_1, newIndices, 0, 0, endIndex);
    $this.dmm_1 = newIndices;
  }
  function JsonPath(configuration) {
    this.bmm_1 = configuration;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.cmm_1 = Array(8);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.dmm_1 = tmp_2;
    this.emm_1 = -1;
  }
  protoOf(JsonPath).fmm = function (sd) {
    this.emm_1 = this.emm_1 + 1 | 0;
    var depth = this.emm_1;
    if (depth === this.cmm_1.length) {
      resize(this);
    }
    this.cmm_1[depth] = sd;
  };
  protoOf(JsonPath).gmm = function (index) {
    this.dmm_1[this.emm_1] = index;
  };
  protoOf(JsonPath).hmm = function (key) {
    var tmp;
    if (!(this.dmm_1[this.emm_1] === -2)) {
      this.emm_1 = this.emm_1 + 1 | 0;
      tmp = this.emm_1 === this.cmm_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.cmm_1[this.emm_1] = this.bmm_1.omi_1 ? key : RedactedKey_instance;
    this.dmm_1[this.emm_1] = -2;
  };
  protoOf(JsonPath).imm = function () {
    if (this.dmm_1[this.emm_1] === -2) {
      this.cmm_1[this.emm_1] = Tombstone_instance;
    }
  };
  protoOf(JsonPath).jmm = function () {
    var depth = this.emm_1;
    if (this.dmm_1[depth] === -2) {
      this.dmm_1[depth] = -1;
      this.emm_1 = this.emm_1 - 1 | 0;
    }
    if (!(this.emm_1 === -1)) {
      this.emm_1 = this.emm_1 - 1 | 0;
    }
  };
  protoOf(JsonPath).kmm = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q('$');
    // Inline function 'kotlin.repeat' call
    var times = this.emm_1 + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = this.cmm_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.u72(), LIST_getInstance())) {
            if (!(this.dmm_1[index] === -1)) {
              this_0.q('[');
              this_0.ed(this.dmm_1[index]);
              this_0.q(']');
            }
          } else {
            var idx = this.dmm_1[index];
            if (idx >= 0) {
              this_0.q('.');
              this_0.q(element.y72(idx));
            }
          }
        } else {
          if (element === RedactedKey_instance) {
            this_0.q('[<debug info disabled>]');
          } else {
            if (!(element === Tombstone_instance)) {
              this_0.q('[');
              this_0.q("'");
              this_0.w(element);
              this_0.q("'");
              this_0.q(']');
            }
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  };
  protoOf(JsonPath).toString = function () {
    return this.kmm();
  };
  function checkKind($this, descriptor, actualClass) {
    var kind = descriptor.u72();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      tmp = equals(kind, CONTEXTUAL_getInstance());
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.o() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    }
    if ($this.lmm_1)
      return Unit_instance;
    if (!$this.mmm_1)
      return Unit_instance;
    var tmp_0;
    var tmp_1;
    if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = kind instanceof ENUM;
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.o() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
    }
  }
  function JsonSerializersModuleValidator(configuration) {
    this.lmm_1 = configuration.fmi_1;
    this.mmm_1 = !configuration.nmi_1.equals(ClassDiscriminatorMode_NONE_getInstance());
  }
  protoOf(JsonSerializersModuleValidator).y7l = function (kClass, provider) {
  };
  protoOf(JsonSerializersModuleValidator).b7m = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.y70();
    checkKind(this, descriptor, actualClass);
  };
  protoOf(JsonSerializersModuleValidator).c7m = function (baseClass, defaultSerializerProvider) {
  };
  protoOf(JsonSerializersModuleValidator).d7m = function (baseClass, defaultDeserializerProvider) {
  };
  function encodeByWriter(json, writer, serializer, value) {
    var tmp = WriteMode_OBJ_getInstance();
    // Inline function 'kotlin.arrayOfNulls' call
    var size = get_entries().n1();
    var tmp$ret$0 = Array(size);
    var encoder = StreamingJsonEncoder_init_$Create$(writer, json, tmp, tmp$ret$0);
    encoder.f76(serializer, value);
  }
  function readObject($this) {
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
    var lastToken = $this.wmm_1.amn(6);
    if ($this.wmm_1.bmn() === 4) {
      $this.wmm_1.wml('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.linkedMapOf' call
    var result = LinkedHashMap_init_$Create$();
    $l$loop: while ($this.wmm_1.cmn()) {
      var key = $this.xmm_1 ? $this.wmm_1.emn() : $this.wmm_1.dmn();
      $this.wmm_1.amn(5);
      var element = $this.fmn();
      // Inline function 'kotlin.collections.set' call
      result.z2(key, element);
      lastToken = $this.wmm_1.gmn();
      var tmp0_subject = lastToken;
      if (tmp0_subject !== 4)
        if (tmp0_subject === 7)
          break $l$loop;
        else {
          $this.wmm_1.wml('Expected end of the object or comma');
        }
    }
    if (lastToken === 6) {
      $this.wmm_1.amn(7);
    } else if (lastToken === 4) {
      if (!$this.ymm_1) {
        invalidTrailingComma($this.wmm_1);
      }
      $this.wmm_1.amn(7);
    }
    return new JsonObject(result);
  }
  function readObject_0($this, $receiver, $completion) {
    var tmp = new $readObjectCOROUTINE$($this, $receiver, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function readArray($this) {
    var lastToken = $this.wmm_1.gmn();
    if ($this.wmm_1.bmn() === 4) {
      $this.wmm_1.wml('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    while ($this.wmm_1.cmn()) {
      var element = $this.fmn();
      result.j1(element);
      lastToken = $this.wmm_1.gmn();
      if (!(lastToken === 4)) {
        var tmp0 = $this.wmm_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = lastToken === 9;
        var position = tmp0.ymg_1;
        if (!condition) {
          var tmp$ret$2 = 'Expected end of the array or comma';
          tmp0.wml(tmp$ret$2, position);
        }
      }
    }
    if (lastToken === 8) {
      $this.wmm_1.amn(9);
    } else if (lastToken === 4) {
      if (!$this.ymm_1) {
        invalidTrailingComma($this.wmm_1, 'array');
      }
      $this.wmm_1.amn(9);
    }
    return new JsonArray(result);
  }
  function readValue($this, isString) {
    var tmp;
    if ($this.xmm_1 || !isString) {
      tmp = $this.wmm_1.emn();
    } else {
      tmp = $this.wmm_1.dmn();
    }
    var string = tmp;
    if (!isString && string === 'null')
      return JsonNull_getInstance();
    return new JsonLiteral(string, isString);
  }
  function readDeepRecursive($this) {
    return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
  }
  function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
    this.dmo_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsonTreeReader$readDeepRecursive$slambda).hmo = function ($this$DeepRecursiveFunction, it, $completion) {
    var tmp = this.imo($this$DeepRecursiveFunction, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.hmo(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_subject = this.dmo_1.wmm_1.bmn();
            if (tmp0_subject === 1) {
              this.gmo_1 = readValue(this.dmo_1, true);
              this.n9_1 = 2;
              continue $sm;
            } else {
              if (tmp0_subject === 0) {
                this.gmo_1 = readValue(this.dmo_1, false);
                this.n9_1 = 2;
                continue $sm;
              } else {
                if (tmp0_subject === 6) {
                  this.n9_1 = 1;
                  suspendResult = readObject_0(this.dmo_1, this.emo_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp0_subject === 8) {
                    this.gmo_1 = readArray(this.dmo_1);
                    this.n9_1 = 2;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    this.dmo_1.wmm_1.wml("Can't begin reading element, unexpected token");
                  }
                }
              }
            }

            break;
          case 1:
            this.gmo_1 = suspendResult;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return this.gmo_1;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).imo = function ($this$DeepRecursiveFunction, it, completion) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this.dmo_1, completion);
    i.emo_1 = $this$DeepRecursiveFunction;
    i.fmo_1 = it;
    return i;
  };
  function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$DeepRecursiveFunction, it, $completion) {
      return i.hmo($this$DeepRecursiveFunction, it, $completion);
    }, 2);
  }
  function $readObjectCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pmn_1 = _this__u8e3s4;
    this.qmn_1 = _this__u8e3s4_0;
  }
  protoOf($readObjectCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.smn_1 = this.pmn_1;
            this.tmn_1 = this.smn_1.wmm_1.amn(6);
            if (this.smn_1.wmm_1.bmn() === 4) {
              this.smn_1.wmm_1.wml('Unexpected leading comma');
            }

            var tmp_0 = this;
            tmp_0.rmn_1 = LinkedHashMap_init_$Create$();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.smn_1.wmm_1.cmn()) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.umn_1 = this.smn_1.xmm_1 ? this.smn_1.wmm_1.emn() : this.smn_1.wmm_1.dmn();
            this.smn_1.wmm_1.amn(5);
            this.n9_1 = 2;
            suspendResult = this.qmn_1.sq(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var element = suspendResult;
            var tmp0 = this.rmn_1;
            var key = this.umn_1;
            tmp0.z2(key, element);
            this.tmn_1 = this.smn_1.wmm_1.gmn();
            var tmp0_subject = this.tmn_1;
            if (tmp0_subject === 4) {
              this.n9_1 = 3;
              continue $sm;
            } else {
              if (tmp0_subject === 7) {
                this.n9_1 = 4;
                continue $sm;
              } else {
                this.smn_1.wmm_1.wml('Expected end of the object or comma');
              }
            }

            break;
          case 3:
            this.n9_1 = 1;
            continue $sm;
          case 4:
            if (this.tmn_1 === 6) {
              this.smn_1.wmm_1.amn(7);
            } else if (this.tmn_1 === 4) {
              if (!this.smn_1.ymm_1) {
                invalidTrailingComma(this.smn_1.wmm_1);
              }
              this.smn_1.wmm_1.amn(7);
            }

            return new JsonObject(this.rmn_1);
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function JsonTreeReader(configuration, lexer) {
    this.wmm_1 = lexer;
    this.xmm_1 = configuration.zmh_1;
    this.ymm_1 = configuration.lmi_1;
    this.zmm_1 = 0;
  }
  protoOf(JsonTreeReader).fmn = function () {
    var token = this.wmm_1.bmn();
    var tmp;
    if (token === 1) {
      tmp = readValue(this, true);
    } else if (token === 0) {
      tmp = readValue(this, false);
    } else if (token === 6) {
      var tmp_0;
      this.zmm_1 = this.zmm_1 + 1 | 0;
      if (this.zmm_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.zmm_1 = this.zmm_1 - 1 | 0;
      tmp = result;
    } else if (token === 8) {
      tmp = readArray(this);
    } else {
      this.wmm_1.wml('Cannot read Json element because of unexpected ' + tokenDescription(token));
    }
    return tmp;
  };
  function classDiscriminator(_this__u8e3s4, json) {
    var _iterator__ex2g4s = _this__u8e3s4.x72().t();
    while (_iterator__ex2g4s.u()) {
      var annotation = _iterator__ex2g4s.v();
      if (annotation instanceof JsonClassDiscriminator)
        return annotation.jmo_1;
    }
    return json.img_1.gmi_1;
  }
  function throwJsonElementPolymorphicException(serialName, element) {
    var tmp0_shortMessage = 'Class with serial name ' + serialName + ' cannot be serialized polymorphically because it is represented as ' + getKClassFromExpression(element).o() + '.';
    throw new JsonEncodingException(tmp0_shortMessage, serialName, 'Make sure that its JsonTransformingSerializer returns JsonObject, so class discriminator can be added to it.');
  }
  function access$checkEncodingConflicts$tPolymorphicKt($receiver, serializer, actualSerializer, classDiscriminator) {
    return checkEncodingConflicts($receiver, serializer, actualSerializer, classDiscriminator);
  }
  function checkKind_0(kind) {
    if (kind instanceof ENUM) {
      // Inline function 'kotlin.error' call
      var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (kind instanceof PrimitiveKind) {
      // Inline function 'kotlin.error' call
      var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    if (kind instanceof PolymorphicKind) {
      // Inline function 'kotlin.error' call
      var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
      throw IllegalStateException_init_$Create$(toString(message_1));
    }
  }
  function checkEncodingConflicts(_this__u8e3s4, serializer, actualSerializer, classDiscriminator) {
    if (getJsonEncodedNames(actualSerializer.y70(), _this__u8e3s4).m1(classDiscriminator)) {
      var baseName = serializer.y70().z71();
      var actualName = actualSerializer.y70().z71();
      var text = _this__u8e3s4.img_1.nmi_1.equals(ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance()) && baseName === actualName ? 'in ALL_JSON_OBJECTS class discriminator mode' : "as base class '" + baseName + "'";
      var tmp0_shortMessage = "Class '" + actualName + "' cannot be serialized " + text + ' because' + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'.");
      var tmp1_hint = 'You can either change class discriminator in JsonConfiguration, or rename property with @SerialName annotation.';
      throw new JsonEncodingException(tmp0_shortMessage, actualName, tmp1_hint);
    }
  }
  function Key() {
  }
  function DescriptorSchemaCache() {
    this.xml_1 = createMapForCache(16);
  }
  protoOf(DescriptorSchemaCache).kmo = function (descriptor, key, value) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.xml_1;
    var value_0 = this_0.w2(descriptor);
    var tmp;
    if (value_0 == null) {
      var answer = createMapForCache(2);
      this_0.z2(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var tmp0 = tmp;
    var tmp2 = key instanceof Key ? key : THROW_CCE();
    // Inline function 'kotlin.collections.set' call
    var value_1 = !(value == null) ? value : THROW_CCE();
    tmp0.z2(tmp2, value_1);
  };
  protoOf(DescriptorSchemaCache).yml = function (descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.lmo(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.kmo(descriptor, key, value);
    return value;
  };
  protoOf(DescriptorSchemaCache).lmo = function (descriptor, key) {
    var tmp0_safe_receiver = this.xml_1.w2(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.w2(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  };
  function DiscriminatorHolder(discriminatorToSkip) {
    this.mmo_1 = discriminatorToSkip;
  }
  function trySkip($this, $receiver, unknownKey) {
    if ($receiver == null)
      return false;
    if ($receiver.mmo_1 === unknownKey) {
      $receiver.mmo_1 = null;
      return true;
    }
    return false;
  }
  function skipLeftoverElements($this, descriptor) {
    while (!($this.e75(descriptor) === -1)) {
    }
  }
  function checkLeadingComma($this) {
    if ($this.rmg_1.bmn() === 4) {
      $this.rmg_1.wml('Unexpected leading comma');
    }
  }
  function decodeMapIndex($this) {
    var hasComma = false;
    var decodingKey = !(($this.tmg_1 % 2 | 0) === 0);
    if (decodingKey) {
      if (!($this.tmg_1 === -1)) {
        hasComma = $this.rmg_1.omo();
      }
    } else {
      $this.rmg_1.nmo(_Char___init__impl__6a9atx(58));
    }
    var tmp;
    if ($this.rmg_1.cmn()) {
      if (decodingKey) {
        if ($this.tmg_1 === -1) {
          var tmp0 = $this.rmg_1;
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var condition = !hasComma;
          var position = tmp0.ymg_1;
          if (!condition) {
            var tmp$ret$1 = 'Unexpected leading comma';
            tmp0.wml(tmp$ret$1, position);
          }
        } else {
          var tmp0_0 = $this.rmg_1;
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var condition_0 = hasComma;
          var position_0 = tmp0_0.ymg_1;
          if (!condition_0) {
            var tmp$ret$3 = 'Expected comma after the key-value pair';
            tmp0_0.wml(tmp$ret$3, position_0);
          }
        }
      }
      $this.tmg_1 = $this.tmg_1 + 1 | 0;
      tmp = $this.tmg_1;
    } else {
      if (hasComma && !$this.pmg_1.img_1.lmi_1) {
        invalidTrailingComma($this.rmg_1);
      }
      tmp = -1;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var tmp0 = $this.pmg_1;
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var isOptional = descriptor.c73(index);
      var elementDescriptor = descriptor.b73(index);
      var tmp;
      if (isOptional && !elementDescriptor.n72()) {
        tmp = $this.rmg_1.pmo(true);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_2;
      }
      if (equals(elementDescriptor.u72(), ENUM_getInstance())) {
        var tmp_0;
        if (elementDescriptor.n72()) {
          tmp_0 = $this.rmg_1.pmo(false);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_2;
        }
        var tmp0_elvis_lhs = $this.rmg_1.qmo($this.vmg_1.zmh_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$0 = false;
          break $l$block_2;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_1;
        var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
        var coerceToNull = !tmp0.img_1.cmi_1 && elementDescriptor.n72();
        if (enumIndex === -3 && (isOptional || coerceToNull)) {
          $this.rmg_1.dmn();
          tmp$ret$0 = true;
          break $l$block_2;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function decodeObjectIndex($this, descriptor) {
    var hasComma = $this.rmg_1.omo();
    while ($this.rmg_1.cmn()) {
      hasComma = false;
      var key = decodeStringKey($this);
      $this.rmg_1.nmo(_Char___init__impl__6a9atx(58));
      var index = getJsonNameIndex(descriptor, $this.pmg_1, key);
      var tmp;
      if (!(index === -3)) {
        var tmp_0;
        if ($this.vmg_1.emi_1 && coerceInputValue($this, descriptor, index)) {
          hasComma = $this.rmg_1.omo();
          tmp_0 = false;
        } else {
          var tmp0_safe_receiver = $this.wmg_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.tml(index);
          }
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown) {
        hasComma = handleUnknown($this, descriptor, key);
      }
    }
    if (hasComma && !$this.pmg_1.img_1.lmi_1) {
      invalidTrailingComma($this.rmg_1);
    }
    var tmp1_safe_receiver = $this.wmg_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.uml();
    return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  }
  function handleUnknown($this, descriptor, key) {
    if (ignoreUnknownKeys(descriptor, $this.pmg_1) || trySkip($this, $this.umg_1, key)) {
      $this.rmg_1.smo($this.vmg_1.zmh_1);
    } else {
      $this.rmg_1.zmg_1.jmm();
      $this.rmg_1.rmo(key);
    }
    return $this.rmg_1.omo();
  }
  function decodeListIndex($this) {
    var hasComma = $this.rmg_1.omo();
    var tmp;
    if ($this.rmg_1.cmn()) {
      if (!($this.tmg_1 === -1) && !hasComma) {
        $this.rmg_1.wml('Expected end of the array or comma');
      }
      $this.tmg_1 = $this.tmg_1 + 1 | 0;
      tmp = $this.tmg_1;
    } else {
      if (hasComma && !$this.pmg_1.img_1.lmi_1) {
        invalidTrailingComma($this.rmg_1, 'array');
      }
      tmp = -1;
    }
    return tmp;
  }
  function decodeStringKey($this) {
    var tmp;
    if ($this.vmg_1.zmh_1) {
      tmp = $this.rmg_1.umo();
    } else {
      tmp = $this.rmg_1.tmo();
    }
    return tmp;
  }
  function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
    AbstractDecoder.call(this);
    this.pmg_1 = json;
    this.qmg_1 = mode;
    this.rmg_1 = lexer;
    this.smg_1 = this.pmg_1.c75();
    this.tmg_1 = -1;
    this.umg_1 = discriminatorHolder;
    this.vmg_1 = this.pmg_1.img_1;
    this.wmg_1 = this.vmg_1.cmi_1 ? null : new JsonElementMarker(descriptor);
  }
  protoOf(StreamingJsonDecoder).pmi = function () {
    return this.pmg_1;
  };
  protoOf(StreamingJsonDecoder).c75 = function () {
    return this.smg_1;
  };
  protoOf(StreamingJsonDecoder).qmi = function () {
    return (new JsonTreeReader(this.pmg_1.img_1, this.rmg_1)).fmn();
  };
  protoOf(StreamingJsonDecoder).m74 = function (deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.pmg_1.img_1.fmi_1;
      }
      if (tmp) {
        return deserializer.a71(this);
      }
      var discriminator = classDiscriminator(deserializer.y70(), this.pmg_1);
      var tmp0_elvis_lhs = this.rmg_1.vmo(discriminator, this.vmg_1.zmh_1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp2 = isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE();
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
          var tmp_1;
          if (!(tmp2 instanceof AbstractPolymorphicSerializer)) {
            tmp_1 = true;
          } else {
            tmp_1 = this.pmi().img_1.fmi_1;
          }
          if (tmp_1) {
            tmp$ret$0 = tmp2.a71(this);
            break $l$block;
          }
          var discriminator_0 = classDiscriminator(tmp2.y70(), this.pmi());
          var tmp2_0 = this.qmi();
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = tmp2.y70().z71();
          if (!(tmp2_0 instanceof JsonObject)) {
            var tmp2_1 = 'Expected ' + getKClass(JsonObject).o() + ', but had ' + getKClassFromExpression(tmp2_0).o() + ' as the serialized body of ' + serialName;
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.rmg_1.zmg_1.kmm();
            var tmp_2;
            if (this.pmi().img_1.omi_1) {
              var tmp$ret$6 = toString(tmp2_0);
              tmp_2 = toString(minify(tmp$ret$6));
            } else {
              tmp_2 = null;
            }
            var inputValue = tmp_2;
            throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, path, null, inputValue), tmp2_1, -1, path, inputValue, null);
          }
          var jsonTree = tmp2_0;
          var tmp0_safe_receiver = jsonTree.je(discriminator_0);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
          var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
          var tmp_3;
          try {
            tmp_3 = findPolymorphicSerializer(tmp2, this, type);
          } catch ($p) {
            var tmp_4;
            if ($p instanceof SerializationException) {
              var it = $p;
              // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
              var shortMessage = ensureNotNull(it.message);
              var tmp_5;
              if (this.pmi().img_1.omi_1) {
                var tmp$ret$10 = jsonTree.toString();
                tmp_5 = toString(minify(tmp$ret$10));
              } else {
                tmp_5 = null;
              }
              var inputValue_0 = tmp_5;
              throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue_0), shortMessage, -1, null, inputValue_0, null);
            } else {
              throw $p;
            }
          }
          var tmp_6 = tmp_3;
          var actualSerializer = isInterface(tmp_6, DeserializationStrategy) ? tmp_6 : THROW_CCE();
          tmp$ret$0 = readPolymorphicJson(this.pmi(), discriminator_0, jsonTree, actualSerializer);
        }
        return tmp$ret$0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var type_0 = tmp_0;
      var tmp_7;
      try {
        tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
      } catch ($p_0) {
        var tmp_8;
        if ($p_0 instanceof SerializationException) {
          var it_0 = $p_0;
          var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
          var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
          this.rmg_1.wml(message, VOID, hint);
        } else {
          throw $p_0;
        }
        tmp_7 = tmp_8;
      }
      var tmp_9 = tmp_7;
      var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy) ? tmp_9 : THROW_CCE();
      this.umg_1 = new DiscriminatorHolder(discriminator);
      return actualSerializer_0.a71(this);
    } catch ($p_1) {
      if ($p_1 instanceof MissingFieldException) {
        var e = $p_1;
        if (contains(ensureNotNull(e.message), 'at path'))
          throw e;
        throw missingFieldExceptionWithNewMessage(e, plus(e.message, ' at path: ') + this.rmg_1.zmg_1.kmm());
      } else {
        throw $p_1;
      }
    }
  };
  protoOf(StreamingJsonDecoder).n74 = function (descriptor) {
    var newMode = switchMode(this.pmg_1, descriptor);
    this.rmg_1.zmg_1.fmm(descriptor);
    this.rmg_1.nmo(newMode.ymo_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.a1_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.pmg_1, newMode, this.rmg_1, descriptor, this.umg_1);
        break;
      default:
        var tmp_0;
        if (this.qmg_1.equals(newMode) && this.pmg_1.img_1.cmi_1) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.pmg_1, newMode, this.rmg_1, descriptor, this.umg_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).o74 = function (descriptor) {
    if (descriptor.w72() === 0 && ignoreUnknownKeys(descriptor, this.pmg_1)) {
      skipLeftoverElements(this, descriptor);
    }
    if (this.rmg_1.omo() && !this.pmg_1.img_1.lmi_1) {
      invalidTrailingComma(this.rmg_1, '');
    }
    this.rmg_1.nmo(this.qmg_1.zmo_1);
    this.rmg_1.zmg_1.jmm();
  };
  protoOf(StreamingJsonDecoder).y73 = function () {
    var tmp;
    var tmp0_safe_receiver = this.wmg_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sml_1;
    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
      tmp = !this.rmg_1.amp();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).z73 = function () {
    return null;
  };
  protoOf(StreamingJsonDecoder).z74 = function (descriptor, index, deserializer, previousValue) {
    var isMapKey = this.qmg_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
    if (isMapKey) {
      this.rmg_1.zmg_1.imm();
    }
    var value = protoOf(AbstractDecoder).z74.call(this, descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.rmg_1.zmg_1.hmm(value);
    }
    return value;
  };
  protoOf(StreamingJsonDecoder).e75 = function (descriptor) {
    var index;
    switch (this.qmg_1.a1_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.qmg_1.equals(WriteMode_MAP_getInstance())) {
      this.rmg_1.zmg_1.gmm(index);
    }
    return index;
  };
  protoOf(StreamingJsonDecoder).a74 = function () {
    return this.rmg_1.bmp();
  };
  protoOf(StreamingJsonDecoder).b74 = function () {
    var value = this.rmg_1.cmp();
    if (!equalsLong(value, fromInt(convertToByte(value)))) {
      this.rmg_1.wml("Failed to parse byte for input '" + value.toString() + "'");
    }
    return convertToByte(value);
  };
  protoOf(StreamingJsonDecoder).c74 = function () {
    var value = this.rmg_1.cmp();
    if (!equalsLong(value, fromInt(convertToShort(value)))) {
      this.rmg_1.wml("Failed to parse short for input '" + value.toString() + "'");
    }
    return convertToShort(value);
  };
  protoOf(StreamingJsonDecoder).d74 = function () {
    var value = this.rmg_1.cmp();
    if (!equalsLong(value, fromInt(convertToInt(value)))) {
      this.rmg_1.wml("Failed to parse int for input '" + value.toString() + "'");
    }
    return convertToInt(value);
  };
  protoOf(StreamingJsonDecoder).e74 = function () {
    return this.rmg_1.cmp();
  };
  protoOf(StreamingJsonDecoder).f74 = function () {
    var tmp0 = this.rmg_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.emn();
      try {
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.wml("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.pmg_1.img_1.hmi_1;
    if (specialFp || isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.rmg_1, result);
  };
  protoOf(StreamingJsonDecoder).g74 = function () {
    var tmp0 = this.rmg_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.emn();
      try {
        tmp$ret$0 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.wml("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.pmg_1.img_1.hmi_1;
    if (specialFp || isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.rmg_1, result);
  };
  protoOf(StreamingJsonDecoder).h74 = function () {
    var string = this.rmg_1.emn();
    if (!(string.length === 1)) {
      this.rmg_1.wml("Expected single char, but got '" + string + "'");
    }
    return charCodeAt(string, 0);
  };
  protoOf(StreamingJsonDecoder).i74 = function () {
    var tmp;
    if (this.vmg_1.zmh_1) {
      tmp = this.rmg_1.umo();
    } else {
      tmp = this.rmg_1.dmn();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).k74 = function (descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.rmg_1, this.pmg_1) : protoOf(AbstractDecoder).k74.call(this, descriptor);
  };
  protoOf(StreamingJsonDecoder).j74 = function (enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.pmg_1, this.i74(), ' at path ' + this.rmg_1.zmg_1.kmm());
  };
  function JsonDecoderForUnsignedTypes(lexer, json) {
    AbstractDecoder.call(this);
    this.dmp_1 = lexer;
    this.emp_1 = json.c75();
  }
  protoOf(JsonDecoderForUnsignedTypes).c75 = function () {
    return this.emp_1;
  };
  protoOf(JsonDecoderForUnsignedTypes).e75 = function (descriptor) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(JsonDecoderForUnsignedTypes).d74 = function () {
    var tmp0 = this.dmp_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.emn();
      try {
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = toUInt(input);
        tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.wml("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(JsonDecoderForUnsignedTypes).e74 = function () {
    var tmp0 = this.dmp_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.emn();
      try {
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = toULong(input);
        tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.wml("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(JsonDecoderForUnsignedTypes).b74 = function () {
    var tmp0 = this.dmp_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.emn();
      try {
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = toUByte(input);
        tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.wml("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(JsonDecoderForUnsignedTypes).c74 = function () {
    var tmp0 = this.dmp_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.emn();
      try {
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = toUShort(input);
        tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.wml("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  function get_unsignedNumberDescriptors() {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return unsignedNumberDescriptors;
  }
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
  }
  function encodeTypeInfo($this, discriminator, serialName) {
    $this.nmm_1.qmk();
    $this.r75(discriminator);
    $this.nmm_1.tmk(_Char___init__impl__6a9atx(58));
    $this.nmm_1.smk();
    $this.r75(serialName);
  }
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this.nmm_1 = composer;
    this.omm_1 = json;
    this.pmm_1 = mode;
    this.qmm_1 = modeReuseCache;
    this.rmm_1 = this.omm_1.c75();
    this.smm_1 = this.omm_1.img_1;
    this.tmm_1 = false;
    this.umm_1 = null;
    this.vmm_1 = null;
    var i = this.pmm_1.a1_1;
    if (!(this.qmm_1 == null)) {
      if (!(this.qmm_1[i] === null) || !(this.qmm_1[i] === this)) {
        this.qmm_1[i] = this;
      }
    }
  }
  protoOf(StreamingJsonEncoder).pmi = function () {
    return this.omm_1;
  };
  protoOf(StreamingJsonEncoder).c75 = function () {
    return this.rmm_1;
  };
  protoOf(StreamingJsonEncoder).amk = function (element) {
    var tmp;
    if (!(this.umm_1 == null)) {
      tmp = !(element instanceof JsonObject);
    } else {
      tmp = false;
    }
    if (tmp) {
      throwJsonElementPolymorphicException(this.vmm_1, element);
    }
    this.f76(JsonElementSerializer_getInstance(), element);
  };
  protoOf(StreamingJsonEncoder).k76 = function (descriptor, index) {
    return this.smm_1.xmh_1;
  };
  protoOf(StreamingJsonEncoder).f76 = function (serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      if (this.pmi().img_1.fmi_1) {
        serializer.z70(this, value);
        break $l$block;
      }
      var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
      var tmp;
      if (isPolymorphicSerializer) {
        tmp = !this.pmi().img_1.nmi_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      } else {
        var tmp_0;
        switch (this.pmi().img_1.nmi_1.a1_1) {
          case 0:
          case 2:
            tmp_0 = false;
            break;
          case 1:
            // Inline function 'kotlin.let' call

            var it = serializer.y70().u72();
            tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      }
      var needDiscriminator = tmp;
      var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.y70(), this.pmi()) : null;
      var tmp_1;
      if (isPolymorphicSerializer) {
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        $l$block_0: {
          // Inline function 'kotlin.requireNotNull' call
          if (value == null) {
            var message = 'Value for serializer ' + toString(serializer.y70()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
            throw IllegalArgumentException_init_$Create$(toString(message));
          } else {
            break $l$block_0;
          }
        }
        var actual = findPolymorphicSerializer_0(casted, this, value);
        tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
      } else {
        tmp_1 = serializer;
      }
      var actualSerializer = tmp_1;
      if (!(baseClassDiscriminator == null)) {
        access$checkEncodingConflicts$tPolymorphicKt(this.pmi(), serializer, actualSerializer, baseClassDiscriminator);
        checkKind_0(actualSerializer.y70().u72());
        var serialName = actualSerializer.y70().z71();
        this.umm_1 = baseClassDiscriminator;
        this.vmm_1 = serialName;
      }
      actualSerializer.z70(this, value);
    }
  };
  protoOf(StreamingJsonEncoder).n74 = function (descriptor) {
    var newMode = switchMode(this.omm_1, descriptor);
    if (!(newMode.ymo_1 === _Char___init__impl__6a9atx(0))) {
      this.nmm_1.tmk(newMode.ymo_1);
      this.nmm_1.omk();
    }
    var discriminator = this.umm_1;
    if (!(discriminator == null)) {
      var tmp0_elvis_lhs = this.vmm_1;
      encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.z71() : tmp0_elvis_lhs);
      this.umm_1 = null;
      this.vmm_1 = null;
    }
    if (this.pmm_1.equals(newMode)) {
      return this;
    }
    var tmp1_safe_receiver = this.qmm_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.a1_1];
    return tmp2_elvis_lhs == null ? new StreamingJsonEncoder(this.nmm_1, this.omm_1, newMode, this.qmm_1) : tmp2_elvis_lhs;
  };
  protoOf(StreamingJsonEncoder).o74 = function (descriptor) {
    if (!(this.pmm_1.zmo_1 === _Char___init__impl__6a9atx(0))) {
      this.nmm_1.pmk();
      this.nmm_1.rmk();
      this.nmm_1.tmk(this.pmm_1.zmo_1);
    }
  };
  protoOf(StreamingJsonEncoder).g75 = function (descriptor, index) {
    switch (this.pmm_1.a1_1) {
      case 1:
        if (!this.nmm_1.nmk_1) {
          this.nmm_1.tmk(_Char___init__impl__6a9atx(44));
        }

        this.nmm_1.qmk();
        break;
      case 2:
        if (!this.nmm_1.nmk_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.nmm_1.tmk(_Char___init__impl__6a9atx(44));
            this.nmm_1.qmk();
            tmp_0 = true;
          } else {
            this.nmm_1.tmk(_Char___init__impl__6a9atx(58));
            this.nmm_1.smk();
            tmp_0 = false;
          }
          tmp.tmm_1 = tmp_0;
        } else {
          this.tmm_1 = true;
          this.nmm_1.qmk();
        }

        break;
      case 3:
        if (index === 0)
          this.tmm_1 = true;
        if (index === 1) {
          this.nmm_1.tmk(_Char___init__impl__6a9atx(44));
          this.nmm_1.smk();
          this.tmm_1 = false;
        }

        break;
      default:
        if (!this.nmm_1.nmk_1) {
          this.nmm_1.tmk(_Char___init__impl__6a9atx(44));
        }

        this.nmm_1.qmk();
        this.r75(getJsonElementName(descriptor, this.omm_1, index));
        this.nmm_1.tmk(_Char___init__impl__6a9atx(58));
        this.nmm_1.smk();
        break;
    }
    return true;
  };
  protoOf(StreamingJsonEncoder).g76 = function (descriptor, index, serializer, value) {
    if (!(value == null) || this.smm_1.cmi_1) {
      protoOf(AbstractEncoder).g76.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(StreamingJsonEncoder).t75 = function (descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.nmm_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.nmm_1;
      } else {
        var tmp0 = this.nmm_1.mmk_1;
        var p1 = this.tmm_1;
        tmp_0 = new ComposerForUnsignedNumbers(tmp0, p1);
      }
      var tmp$ret$0 = tmp_0;
      tmp = new StreamingJsonEncoder(tmp$ret$0, this.omm_1, this.pmm_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.nmm_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.nmm_1;
      } else {
        var tmp0_0 = this.nmm_1.mmk_1;
        var p1_0 = this.tmm_1;
        tmp_2 = new ComposerForUnquotedLiterals(tmp0_0, p1_0);
      }
      var tmp$ret$2 = tmp_2;
      tmp = new StreamingJsonEncoder(tmp$ret$2, this.omm_1, this.pmm_1, null);
    } else if (!(this.umm_1 == null)) {
      // Inline function 'kotlin.apply' call
      this.vmm_1 = descriptor.z71();
      tmp = this;
    } else {
      tmp = protoOf(AbstractEncoder).t75.call(this, descriptor);
    }
    return tmp;
  };
  protoOf(StreamingJsonEncoder).i75 = function () {
    this.nmm_1.vmk('null');
  };
  protoOf(StreamingJsonEncoder).j75 = function (value) {
    if (this.tmm_1) {
      this.r75(value.toString());
    } else {
      this.nmm_1.eml(value);
    }
  };
  protoOf(StreamingJsonEncoder).k75 = function (value) {
    if (this.tmm_1) {
      this.r75(value.toString());
    } else {
      this.nmm_1.zmk(value);
    }
  };
  protoOf(StreamingJsonEncoder).l75 = function (value) {
    if (this.tmm_1) {
      this.r75(value.toString());
    } else {
      this.nmm_1.bml(value);
    }
  };
  protoOf(StreamingJsonEncoder).m75 = function (value) {
    if (this.tmm_1) {
      this.r75(value.toString());
    } else {
      this.nmm_1.cml(value);
    }
  };
  protoOf(StreamingJsonEncoder).n75 = function (value) {
    if (this.tmm_1) {
      this.r75(value.toString());
    } else {
      this.nmm_1.dml(value);
    }
  };
  protoOf(StreamingJsonEncoder).o75 = function (value) {
    if (this.tmm_1) {
      this.r75(value.toString());
    } else {
      this.nmm_1.xmk(value);
    }
    if (!this.smm_1.hmi_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value);
    }
  };
  protoOf(StreamingJsonEncoder).p75 = function (value) {
    if (this.tmm_1) {
      this.r75(value.toString());
    } else {
      this.nmm_1.ymk(value);
    }
    if (!this.smm_1.hmi_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value);
    }
  };
  protoOf(StreamingJsonEncoder).q75 = function (value) {
    this.r75(toString_1(value));
  };
  protoOf(StreamingJsonEncoder).r75 = function (value) {
    return this.nmm_1.fml(value);
  };
  protoOf(StreamingJsonEncoder).s75 = function (enumDescriptor, index) {
    this.r75(enumDescriptor.y72(index));
  };
  function get_isUnsignedNumber(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.v72() && get_unsignedNumberDescriptors().m1(_this__u8e3s4);
  }
  function get_isUnquotedLiteral(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.v72() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
  }
  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
    if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
      unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).y70(), serializer_0(Companion_getInstance()).y70(), serializer_2(Companion_getInstance_1()).y70(), serializer_3(Companion_getInstance_2()).y70()]);
    }
  }
  function get_ESCAPE_STRINGS() {
    _init_properties_StringOps_kt__fcy1db();
    return ESCAPE_STRINGS;
  }
  var ESCAPE_STRINGS;
  var ESCAPE_MARKERS;
  function toHexChar(i) {
    _init_properties_StringOps_kt__fcy1db();
    var d = i & 15;
    var tmp;
    if (d < 10) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      tmp = numberToChar(d + tmp$ret$0 | 0);
    } else {
      var tmp_0 = d - 10 | 0;
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
    }
    return tmp;
  }
  function printQuoted(_this__u8e3s4, value) {
    _init_properties_StringOps_kt__fcy1db();
    _this__u8e3s4.s(_Char___init__impl__6a9atx(34));
    var lastPos = 0;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(value, i);
        var c = Char__toInt_impl_vasixd(this_0);
        if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
          _this__u8e3s4.bd(value, lastPos, i);
          _this__u8e3s4.q(get_ESCAPE_STRINGS()[c]);
          lastPos = i + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    if (!(lastPos === 0))
      _this__u8e3s4.bd(value, lastPos, value.length);
    else
      _this__u8e3s4.q(value);
    _this__u8e3s4.s(_Char___init__impl__6a9atx(34));
  }
  function toBooleanStrictOrNull_0(_this__u8e3s4) {
    _init_properties_StringOps_kt__fcy1db();
    return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
  }
  var properties_initialized_StringOps_kt_wzaea7;
  function _init_properties_StringOps_kt__fcy1db() {
    if (!properties_initialized_StringOps_kt_wzaea7) {
      properties_initialized_StringOps_kt_wzaea7 = true;
      // Inline function 'kotlin.arrayOfNulls' call
      // Inline function 'kotlin.apply' call
      var this_0 = Array(93);
      var inductionVariable = 0;
      if (inductionVariable <= 31)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var c1 = toHexChar(c >> 12);
          var c2 = toHexChar(c >> 8);
          var c3 = toHexChar(c >> 4);
          var c4 = toHexChar(c);
          this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
        }
         while (inductionVariable <= 31);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(34);
      this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(92);
      this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(9);
      this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(8);
      this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(10);
      this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
      // Inline function 'kotlin.code' call
      var this_6 = _Char___init__impl__6a9atx(13);
      this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
      this_0[12] = '\\f';
      ESCAPE_STRINGS = this_0;
      // Inline function 'kotlin.apply' call
      var this_7 = new Int8Array(93);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 31)
        do {
          var c_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_7[c_0] = 1;
        }
         while (inductionVariable_0 <= 31);
      // Inline function 'kotlin.code' call
      var this_8 = _Char___init__impl__6a9atx(34);
      var tmp = Char__toInt_impl_vasixd(this_8);
      // Inline function 'kotlin.code' call
      var this_9 = _Char___init__impl__6a9atx(34);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_9);
      this_7[tmp] = toByte(tmp$ret$3);
      // Inline function 'kotlin.code' call
      var this_10 = _Char___init__impl__6a9atx(92);
      var tmp_0 = Char__toInt_impl_vasixd(this_10);
      // Inline function 'kotlin.code' call
      var this_11 = _Char___init__impl__6a9atx(92);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_11);
      this_7[tmp_0] = toByte(tmp$ret$5);
      // Inline function 'kotlin.code' call
      var this_12 = _Char___init__impl__6a9atx(9);
      var tmp_1 = Char__toInt_impl_vasixd(this_12);
      // Inline function 'kotlin.code' call
      var this_13 = _Char___init__impl__6a9atx(116);
      var tmp$ret$7 = Char__toInt_impl_vasixd(this_13);
      this_7[tmp_1] = toByte(tmp$ret$7);
      // Inline function 'kotlin.code' call
      var this_14 = _Char___init__impl__6a9atx(8);
      var tmp_2 = Char__toInt_impl_vasixd(this_14);
      // Inline function 'kotlin.code' call
      var this_15 = _Char___init__impl__6a9atx(98);
      var tmp$ret$9 = Char__toInt_impl_vasixd(this_15);
      this_7[tmp_2] = toByte(tmp$ret$9);
      // Inline function 'kotlin.code' call
      var this_16 = _Char___init__impl__6a9atx(10);
      var tmp_3 = Char__toInt_impl_vasixd(this_16);
      // Inline function 'kotlin.code' call
      var this_17 = _Char___init__impl__6a9atx(110);
      var tmp$ret$11 = Char__toInt_impl_vasixd(this_17);
      this_7[tmp_3] = toByte(tmp$ret$11);
      // Inline function 'kotlin.code' call
      var this_18 = _Char___init__impl__6a9atx(13);
      var tmp_4 = Char__toInt_impl_vasixd(this_18);
      // Inline function 'kotlin.code' call
      var this_19 = _Char___init__impl__6a9atx(114);
      var tmp$ret$13 = Char__toInt_impl_vasixd(this_19);
      this_7[tmp_4] = toByte(tmp$ret$13);
      // Inline function 'kotlin.code' call
      var this_20 = _Char___init__impl__6a9atx(102);
      var tmp$ret$14 = Char__toInt_impl_vasixd(this_20);
      this_7[12] = toByte(tmp$ret$14);
      ESCAPE_MARKERS = this_7;
    }
  }
  function readJson(json, element, deserializer) {
    var tmp;
    if (element instanceof JsonObject) {
      tmp = new JsonTreeDecoder(json, element);
    } else {
      if (element instanceof JsonArray) {
        tmp = new JsonTreeListDecoder(json, element);
      } else {
        var tmp_0;
        if (element instanceof JsonLiteral) {
          tmp_0 = true;
        } else {
          tmp_0 = equals(element, JsonNull_getInstance());
        }
        if (tmp_0) {
          tmp = new JsonPrimitiveDecoder(json, element instanceof JsonPrimitive ? element : THROW_CCE());
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    var input = tmp;
    return input.m74(deserializer);
  }
  function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.y70())).m74(deserializer);
  }
  function unparsedPrimitive($this, literal, primitive, tag) {
    var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
    var tmp2 = "Failed to parse literal '" + literal.toString() + "' as " + type + ' value';
    // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
    var path = $this.lmp(tag);
    var tmp;
    if ($this.pmi().img_1.omi_1) {
      var tmp$ret$3 = toString($this.mmp());
      tmp = toString(minify(tmp$ret$3));
    } else {
      tmp = null;
    }
    var inputValue = tmp;
    throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
  }
  function AbstractJsonTreeDecoder(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    NamedValueDecoder.call(this);
    this.hmp_1 = json;
    this.imp_1 = value;
    this.jmp_1 = polymorphicDiscriminator;
    this.kmp_1 = this.pmi().img_1;
  }
  protoOf(AbstractJsonTreeDecoder).pmi = function () {
    return this.hmp_1;
  };
  protoOf(AbstractJsonTreeDecoder).u1 = function () {
    return this.imp_1;
  };
  protoOf(AbstractJsonTreeDecoder).c75 = function () {
    return this.pmi().c75();
  };
  protoOf(AbstractJsonTreeDecoder).mmp = function () {
    var tmp0_safe_receiver = this.w7i();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.nmp(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? this.u1() : tmp1_elvis_lhs;
  };
  protoOf(AbstractJsonTreeDecoder).lmp = function (currentTag) {
    return this.y7i() + ('.' + currentTag);
  };
  protoOf(AbstractJsonTreeDecoder).qmi = function () {
    return this.mmp();
  };
  protoOf(AbstractJsonTreeDecoder).m74 = function (deserializer) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.pmi().img_1.fmi_1;
      }
      if (tmp) {
        tmp$ret$0 = deserializer.a71(this);
        break $l$block;
      }
      var discriminator = classDiscriminator(deserializer.y70(), this.pmi());
      var tmp2 = this.qmi();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = deserializer.y70().z71();
      if (!(tmp2 instanceof JsonObject)) {
        var tmp2_0 = 'Expected ' + getKClass(JsonObject).o() + ', but had ' + getKClassFromExpression(tmp2).o() + ' as the serialized body of ' + serialName;
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.y7i();
        var tmp_0;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$6 = toString(tmp2);
          tmp_0 = toString(minify(tmp$ret$6));
        } else {
          tmp_0 = null;
        }
        var inputValue = tmp_0;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
      }
      var jsonTree = tmp2;
      var tmp0_safe_receiver = jsonTree.je(discriminator);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
      var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
      var tmp_1;
      try {
        tmp_1 = findPolymorphicSerializer(deserializer, this, type);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof SerializationException) {
          var it = $p;
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var shortMessage = ensureNotNull(it.message);
          var tmp_3;
          if (this.pmi().img_1.omi_1) {
            var tmp$ret$10 = jsonTree.toString();
            tmp_3 = toString(minify(tmp$ret$10));
          } else {
            tmp_3 = null;
          }
          var inputValue_0 = tmp_3;
          throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue_0), shortMessage, -1, null, inputValue_0, null);
        } else {
          throw $p;
        }
      }
      var tmp_4 = tmp_1;
      var actualSerializer = isInterface(tmp_4, DeserializationStrategy) ? tmp_4 : THROW_CCE();
      tmp$ret$0 = readPolymorphicJson(this.pmi(), discriminator, jsonTree, actualSerializer);
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).x7i = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeDecoder).n74 = function (descriptor) {
    var currentObject = this.mmp();
    var tmp0_subject = descriptor.u72();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.pmi();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = descriptor.z71();
      if (!(currentObject instanceof JsonArray)) {
        var tmp2 = 'Expected ' + getKClass(JsonArray).o() + ', but had ' + getKClassFromExpression(currentObject).o() + ' as the serialized body of ' + serialName;
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.y7i();
        var tmp_2;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$6 = toString(currentObject);
          tmp_2 = toString(minify(tmp$ret$6));
        } else {
          tmp_2 = null;
        }
        var inputValue = tmp_2;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.pmi();
        var keyDescriptor = carrierDescriptor(descriptor.b73(0), this_0.c75());
        var keyKind = keyDescriptor.u72();
        var tmp_3;
        var tmp_4;
        if (keyKind instanceof PrimitiveKind) {
          tmp_4 = true;
        } else {
          tmp_4 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_4) {
          var tmp_5 = this.pmi();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName_0 = descriptor.z71();
          if (!(currentObject instanceof JsonObject)) {
            var tmp2_0 = 'Expected ' + getKClass(JsonObject).o() + ', but had ' + getKClassFromExpression(currentObject).o() + ' as the serialized body of ' + serialName_0;
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path_0 = this.y7i();
            var tmp_6;
            if (this.pmi().img_1.omi_1) {
              var tmp$ret$15 = toString(currentObject);
              tmp_6 = toString(minify(tmp$ret$15));
            } else {
              tmp_6 = null;
            }
            var inputValue_0 = tmp_6;
            throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path_0, null, inputValue_0), tmp2_0, -1, path_0, inputValue_0, null);
          }
          tmp_3 = new JsonTreeMapDecoder(tmp_5, currentObject);
        } else {
          if (this_0.img_1.ami_1) {
            var tmp_7 = this.pmi();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName_1 = descriptor.z71();
            if (!(currentObject instanceof JsonArray)) {
              var tmp2_1 = 'Expected ' + getKClass(JsonArray).o() + ', but had ' + getKClassFromExpression(currentObject).o() + ' as the serialized body of ' + serialName_1;
              // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
              var path_1 = this.y7i();
              var tmp_8;
              if (this.pmi().img_1.omi_1) {
                var tmp$ret$23 = toString(currentObject);
                tmp_8 = toString(minify(tmp$ret$23));
              } else {
                tmp_8 = null;
              }
              var inputValue_1 = tmp_8;
              throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, path_1, null, inputValue_1), tmp2_1, -1, path_1, inputValue_1, null);
            }
            tmp_3 = new JsonTreeListDecoder(tmp_7, currentObject);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_3;
      } else {
        var tmp_9 = this.pmi();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName_2 = descriptor.z71();
        if (!(currentObject instanceof JsonObject)) {
          var tmp2_2 = 'Expected ' + getKClass(JsonObject).o() + ', but had ' + getKClassFromExpression(currentObject).o() + ' as the serialized body of ' + serialName_2;
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var path_2 = this.y7i();
          var tmp_10;
          if (this.pmi().img_1.omi_1) {
            var tmp$ret$30 = toString(currentObject);
            tmp_10 = toString(minify(tmp$ret$30));
          } else {
            tmp_10 = null;
          }
          var inputValue_2 = tmp_10;
          throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_2, path_2, null, inputValue_2), tmp2_2, -1, path_2, inputValue_2, null);
        }
        tmp = new JsonTreeDecoder(tmp_9, currentObject, this.jmp_1);
      }
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).o74 = function (descriptor) {
  };
  protoOf(AbstractJsonTreeDecoder).y73 = function () {
    var tmp = this.mmp();
    return !(tmp instanceof JsonNull);
  };
  protoOf(AbstractJsonTreeDecoder).omp = function (tag, enumDescriptor) {
    var tmp = this.pmi();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    var tmp2 = this.nmp(tag);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = enumDescriptor.z71();
    if (!(tmp2 instanceof JsonPrimitive)) {
      var tmp2_0 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(tmp2).o() + ' as the serialized body of ' + serialName;
      // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
      var path = this.lmp(tag);
      var tmp_0;
      if (this.pmi().img_1.omi_1) {
        var tmp$ret$7 = toString(tmp2);
        tmp_0 = toString(minify(tmp$ret$7));
      } else {
        tmp_0 = null;
      }
      var inputValue = tmp_0;
      throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
    }
    return getJsonNameIndexOrThrow(enumDescriptor, tmp, tmp2.rj3());
  };
  protoOf(AbstractJsonTreeDecoder).k7j = function (tag, enumDescriptor) {
    return this.omp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).pmp = function (tag) {
    return !(this.nmp(tag) === JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeDecoder).a7j = function (tag) {
    return this.pmp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).qmp = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.nmp(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp2 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(value).o() + ' as the serialized body of ' + 'boolean';
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.lmp(tag);
        var tmp;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$7 = toString(value);
          tmp = toString(minify(tmp$ret$7));
        } else {
          tmp = null;
        }
        var inputValue = tmp;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_booleanOrNull(literal);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).b7j = function (tag) {
    return this.qmp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).rmp = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.nmp(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp2 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(value).o() + ' as the serialized body of ' + 'byte';
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.lmp(tag);
        var tmp;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$7 = toString(value);
          tmp = toString(minify(tmp$ret$7));
        } else {
          tmp = null;
        }
        var inputValue = tmp;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
      }
      var literal = value;
      try {
        var result = parseLongImpl(literal);
        var tmp_0;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-128, 127);
        if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
          tmp_0 = convertToByte(result);
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).c7j = function (tag) {
    return this.rmp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).smp = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.nmp(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp2 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(value).o() + ' as the serialized body of ' + 'short';
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.lmp(tag);
        var tmp;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$7 = toString(value);
          tmp = toString(minify(tmp$ret$7));
        } else {
          tmp = null;
        }
        var inputValue = tmp;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
      }
      var literal = value;
      try {
        var result = parseLongImpl(literal);
        var tmp_0;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-32768, 32767);
        if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
          tmp_0 = convertToShort(result);
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).d7j = function (tag) {
    return this.smp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).tmp = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.nmp(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp2 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(value).o() + ' as the serialized body of ' + 'int';
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.lmp(tag);
        var tmp;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$7 = toString(value);
          tmp = toString(minify(tmp$ret$7));
        } else {
          tmp = null;
        }
        var inputValue = tmp;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
      }
      var literal = value;
      try {
        var result = parseLongImpl(literal);
        var tmp_0;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-2147483648, 2147483647);
        if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
          tmp_0 = convertToInt(result);
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).e7j = function (tag) {
    return this.tmp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).ump = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.nmp(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp2 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(value).o() + ' as the serialized body of ' + 'long';
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.lmp(tag);
        var tmp;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$7 = toString(value);
          tmp = toString(minify(tmp$ret$7));
        } else {
          tmp = null;
        }
        var inputValue = tmp;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = parseLongImpl(literal);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).f7j = function (tag) {
    return this.ump((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).vmp = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.nmp(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp2 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(value).o() + ' as the serialized body of ' + 'float';
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.lmp(tag);
        var tmp;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$7 = toString(value);
          tmp = toString(minify(tmp$ret$7));
        } else {
          tmp = null;
        }
        var inputValue = tmp;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_float(literal);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.pmi().img_1.hmi_1;
    if (specialFp || isFinite(result))
      return result;
    // Inline function 'kotlinx.serialization.json.internal.InvalidFloatingPointDecoded' call
    var tmp2_0 = access$nonFiniteFpMessage$tJsonExceptionsKt(result, tag);
    // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
    var hint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
    var tmp_1;
    if (this.pmi().img_1.omi_1) {
      var tmp$ret$13 = toString(this.mmp());
      tmp_1 = toString(minify(tmp$ret$13));
    } else {
      tmp_1 = null;
    }
    var inputValue_0 = tmp_1;
    throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, null, hint, inputValue_0), tmp2_0, -1, null, inputValue_0, hint);
  };
  protoOf(AbstractJsonTreeDecoder).g7j = function (tag) {
    return this.vmp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).wmp = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.nmp(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp2 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(value).o() + ' as the serialized body of ' + 'double';
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.lmp(tag);
        var tmp;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$7 = toString(value);
          tmp = toString(minify(tmp$ret$7));
        } else {
          tmp = null;
        }
        var inputValue = tmp;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_double(literal);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.pmi().img_1.hmi_1;
    if (specialFp || isFinite_0(result))
      return result;
    // Inline function 'kotlinx.serialization.json.internal.InvalidFloatingPointDecoded' call
    var tmp2_0 = access$nonFiniteFpMessage$tJsonExceptionsKt(result, tag);
    // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
    var hint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
    var tmp_1;
    if (this.pmi().img_1.omi_1) {
      var tmp$ret$13 = toString(this.mmp());
      tmp_1 = toString(minify(tmp$ret$13));
    } else {
      tmp_1 = null;
    }
    var inputValue_0 = tmp_1;
    throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, null, hint, inputValue_0), tmp2_0, -1, null, inputValue_0, hint);
  };
  protoOf(AbstractJsonTreeDecoder).h7j = function (tag) {
    return this.wmp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).xmp = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.nmp(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp2 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(value).o() + ' as the serialized body of ' + 'char';
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.lmp(tag);
        var tmp;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$7 = toString(value);
          tmp = toString(minify(tmp$ret$7));
        } else {
          tmp = null;
        }
        var inputValue = tmp;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = new Char(single(literal.rj3()));
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_0.f2_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).i7j = function (tag) {
    return this.xmp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).ymp = function (tag) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.nmp(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp2 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(value).o() + ' as the serialized body of ' + 'string';
      // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
      var path = this.lmp(tag);
      var tmp;
      if (this.pmi().img_1.omi_1) {
        var tmp$ret$6 = toString(value);
        tmp = toString(minify(tmp$ret$6));
      } else {
        tmp = null;
      }
      var inputValue = tmp;
      throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
    }
    var value_0 = value;
    if (!(value_0 instanceof JsonLiteral)) {
      var tmp2_0 = "Expected string value for a non-null key '" + tag + "', got null literal instead";
      var tmp4 = this.lmp(tag);
      // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
      var hint = "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.";
      var tmp_0;
      if (this.pmi().img_1.omi_1) {
        var tmp$ret$10 = toString(this.mmp());
        tmp_0 = toString(minify(tmp$ret$10));
      } else {
        tmp_0 = null;
      }
      var inputValue_0 = tmp_0;
      throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, tmp4, hint, inputValue_0), tmp2_0, -1, tmp4, inputValue_0, hint);
    }
    if (!value_0.bmj_1 && !this.pmi().img_1.zmh_1) {
      var tmp2_1 = "String literal for value of key '" + tag + "' should be quoted";
      var tmp4_0 = this.lmp(tag);
      // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
      var hint_0 = "Use 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.";
      var tmp_1;
      if (this.pmi().img_1.omi_1) {
        var tmp$ret$14 = toString(this.mmp());
        tmp_1 = toString(minify(tmp$ret$14));
      } else {
        tmp_1 = null;
      }
      var inputValue_1 = tmp_1;
      throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, tmp4_0, hint_0, inputValue_1), tmp2_1, -1, tmp4_0, inputValue_1, hint_0);
    }
    return value_0.dmj_1;
  };
  protoOf(AbstractJsonTreeDecoder).j7j = function (tag) {
    return this.ymp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).zmp = function (tag, inlineDescriptor) {
    var tmp;
    if (get_isUnsignedNumber(inlineDescriptor)) {
      var tmp_0 = this.pmi();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      var tmp2 = this.nmp(tag);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = inlineDescriptor.z71();
      if (!(tmp2 instanceof JsonPrimitive)) {
        var tmp2_0 = 'Expected ' + getKClass(JsonPrimitive).o() + ', but had ' + getKClassFromExpression(tmp2).o() + ' as the serialized body of ' + serialName;
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.lmp(tag);
        var tmp_1;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$7 = toString(tmp2);
          tmp_1 = toString(minify(tmp$ret$7));
        } else {
          tmp_1 = null;
        }
        var inputValue = tmp_1;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
      }
      var lexer = StringJsonLexer_0(tmp_0, tmp2.rj3());
      tmp = new JsonDecoderForUnsignedTypes(lexer, this.pmi());
    } else {
      tmp = protoOf(NamedValueDecoder).l7j.call(this, tag, inlineDescriptor);
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).l7j = function (tag, inlineDescriptor) {
    return this.zmp((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).k74 = function (descriptor) {
    return !(this.w7i() == null) ? protoOf(NamedValueDecoder).k74.call(this, descriptor) : (new JsonPrimitiveDecoder(this.pmi(), this.u1(), this.jmp_1)).k74(descriptor);
  };
  function setForceNull($this, descriptor, index) {
    $this.jmq_1 = (!$this.pmi().img_1.cmi_1 && !descriptor.c73(index) && descriptor.b73(index).n72());
    return $this.jmq_1;
  }
  function JsonTreeDecoder(json, value, polymorphicDiscriminator, polyDescriptor) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
    this.gmq_1 = value;
    this.hmq_1 = polyDescriptor;
    this.imq_1 = 0;
    this.jmq_1 = false;
  }
  protoOf(JsonTreeDecoder).u1 = function () {
    return this.gmq_1;
  };
  protoOf(JsonTreeDecoder).e75 = function (descriptor) {
    $l$loop: while (this.imq_1 < descriptor.w72()) {
      var _unary__edvuaz = this.imq_1;
      this.imq_1 = _unary__edvuaz + 1 | 0;
      var name = this.r7i(descriptor, _unary__edvuaz);
      var index = this.imq_1 - 1 | 0;
      this.jmq_1 = false;
      var tmp;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.u1();
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(name)) {
        tmp = true;
      } else {
        tmp = setForceNull(this, descriptor, index);
      }
      if (tmp) {
        if (!this.kmp_1.emi_1)
          return index;
        var tmp0 = this.pmi();
        var tmp$ret$2;
        $l$block_2: {
          // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
          var isOptional = descriptor.c73(index);
          var elementDescriptor = descriptor.b73(index);
          var tmp_0;
          if (isOptional && !elementDescriptor.n72()) {
            var tmp_1 = this.kmq(name);
            tmp_0 = tmp_1 instanceof JsonNull;
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$2 = true;
            break $l$block_2;
          }
          if (equals(elementDescriptor.u72(), ENUM_getInstance())) {
            var tmp_2;
            if (elementDescriptor.n72()) {
              var tmp_3 = this.kmq(name);
              tmp_2 = tmp_3 instanceof JsonNull;
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp$ret$2 = false;
              break $l$block_2;
            }
            var tmp_4 = this.kmq(name);
            var tmp0_safe_receiver = tmp_4 instanceof JsonPrimitive ? tmp_4 : null;
            var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
            var tmp_5;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$2 = false;
              break $l$block_2;
            } else {
              tmp_5 = tmp0_elvis_lhs;
            }
            var enumValue = tmp_5;
            var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
            var coerceToNull = !tmp0.img_1.cmi_1 && elementDescriptor.n72();
            if (enumIndex === -3 && (isOptional || coerceToNull)) {
              if (setForceNull(this, descriptor, index))
                return index;
              tmp$ret$2 = true;
              break $l$block_2;
            }
          }
          tmp$ret$2 = false;
        }
        if (tmp$ret$2)
          continue $l$loop;
        return index;
      }
    }
    return -1;
  };
  protoOf(JsonTreeDecoder).y73 = function () {
    return !this.jmq_1 && protoOf(AbstractJsonTreeDecoder).y73.call(this);
  };
  protoOf(JsonTreeDecoder).s7i = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.pmi());
    var baseName = descriptor.y72(index);
    if (strategy == null) {
      if (!this.kmp_1.imi_1)
        return baseName;
      if (this.u1().x2().m1(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.pmi(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var tmp0 = this.u1().x2();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (deserializationNamesMap_0.w2(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.amm(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  };
  protoOf(JsonTreeDecoder).nmp = function (tag) {
    return getValue(this.u1(), tag);
  };
  protoOf(JsonTreeDecoder).kmq = function (tag) {
    return this.u1().je(tag);
  };
  protoOf(JsonTreeDecoder).n74 = function (descriptor) {
    if (descriptor === this.hmq_1) {
      var tmp = this.pmi();
      var tmp2 = this.mmp();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = this.hmq_1.z71();
      if (!(tmp2 instanceof JsonObject)) {
        var tmp2_0 = 'Expected ' + getKClass(JsonObject).o() + ', but had ' + getKClassFromExpression(tmp2).o() + ' as the serialized body of ' + serialName;
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var path = this.y7i();
        var tmp_0;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$6 = toString(tmp2);
          tmp_0 = toString(minify(tmp$ret$6));
        } else {
          tmp_0 = null;
        }
        var inputValue = tmp_0;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
      }
      return new JsonTreeDecoder(tmp, tmp2, this.jmp_1, this.hmq_1);
    }
    return protoOf(AbstractJsonTreeDecoder).n74.call(this, descriptor);
  };
  protoOf(JsonTreeDecoder).o74 = function (descriptor) {
    var tmp;
    if (ignoreUnknownKeys(descriptor, this.pmi())) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.u72();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.pmi());
    var tmp_1;
    if (strategy == null && !this.kmp_1.imi_1) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.pmi(), descriptor).x2();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      var tmp0_safe_receiver = get_schemaCache(this.pmi()).lmo(descriptor, get_JsonDeserializationNamesKey());
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x2();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_0(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var _iterator__ex2g4s = this.u1().x2().t();
    while (_iterator__ex2g4s.u()) {
      var key = _iterator__ex2g4s.v();
      if (!names.m1(key) && !(key === this.jmp_1)) {
        var tmp2 = "Encountered an unknown key '" + key + "'";
        var tmp4 = this.y7i();
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var hint = "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.";
        var tmp_3;
        if (this.pmi().img_1.omi_1) {
          var tmp$ret$4 = this.u1().toString();
          tmp_3 = toString(minify(tmp$ret$4));
        } else {
          tmp_3 = null;
        }
        var inputValue = tmp_3;
        throw new JsonDecodingException(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, tmp4, hint, inputValue), tmp2, -1, tmp4, inputValue, hint);
      }
    }
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.rmq_1 = value;
    this.smq_1 = this.rmq_1.n1();
    this.tmq_1 = -1;
  }
  protoOf(JsonTreeListDecoder).u1 = function () {
    return this.rmq_1;
  };
  protoOf(JsonTreeListDecoder).s7i = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListDecoder).nmp = function (tag) {
    return this.rmq_1.l1(toInt(tag));
  };
  protoOf(JsonTreeListDecoder).e75 = function (descriptor) {
    while (this.tmq_1 < (this.smq_1 - 1 | 0)) {
      this.tmq_1 = this.tmq_1 + 1 | 0;
      return this.tmq_1;
    }
    return -1;
  };
  function JsonPrimitiveDecoder(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
    this.amr_1 = value;
    this.m7j('primitive');
  }
  protoOf(JsonPrimitiveDecoder).u1 = function () {
    return this.amr_1;
  };
  protoOf(JsonPrimitiveDecoder).e75 = function (descriptor) {
    return 0;
  };
  protoOf(JsonPrimitiveDecoder).nmp = function (tag) {
    // Inline function 'kotlin.require' call
    if (!(tag === 'primitive')) {
      var message = "This input can only handle primitives with 'primitive' tag";
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.amr_1;
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder.call(this, json, value);
    this.lmr_1 = value;
    this.mmr_1 = toList(this.lmr_1.x2());
    this.nmr_1 = imul(this.mmr_1.n1(), 2);
    this.omr_1 = -1;
  }
  protoOf(JsonTreeMapDecoder).u1 = function () {
    return this.lmr_1;
  };
  protoOf(JsonTreeMapDecoder).s7i = function (descriptor, index) {
    var i = index / 2 | 0;
    return this.mmr_1.l1(i);
  };
  protoOf(JsonTreeMapDecoder).e75 = function (descriptor) {
    while (this.omr_1 < (this.nmr_1 - 1 | 0)) {
      this.omr_1 = this.omr_1 + 1 | 0;
      return this.omr_1;
    }
    return -1;
  };
  protoOf(JsonTreeMapDecoder).nmp = function (tag) {
    return (this.omr_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.lmr_1, tag);
  };
  protoOf(JsonTreeMapDecoder).o74 = function (descriptor) {
  };
  function writeJson(json, value, serializer) {
    var result = {_v: null};
    var encoder = new JsonTreeEncoder(json, writeJson$lambda(result));
    encoder.f76(serializer, value);
    var tmp;
    if (result._v == null) {
      throwUninitializedPropertyAccessException('result');
    } else {
      tmp = result._v;
    }
    return tmp;
  }
  function JsonTreeEncoder(json, nodeConsumer) {
    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.bms_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonTreeEncoder).cms = function (key, element) {
    // Inline function 'kotlin.collections.set' call
    this.bms_1.z2(key, element);
  };
  protoOf(JsonTreeEncoder).g76 = function (descriptor, index, serializer, value) {
    if (!(value == null) || this.smr_1.cmi_1) {
      protoOf(AbstractJsonTreeEncoder).g76.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(JsonTreeEncoder).dms = function () {
    return new JsonObject(this.bms_1);
  };
  function inlineUnsignedNumberEncoder($this, tag) {
    return new AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1($this, tag);
  }
  function inlineUnquotedLiteralEncoder($this, tag, inlineDescriptor) {
    return new AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1($this, tag, inlineDescriptor);
  }
  function AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1(this$0, $tag) {
    this.sms_1 = this$0;
    this.tms_1 = $tag;
    AbstractEncoder.call(this);
    this.rms_1 = this$0.qmr_1.c75();
  }
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).c75 = function () {
    return this.rms_1;
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).ums = function (s) {
    return this.sms_1.cms(this.tms_1, new JsonLiteral(s, false));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).m75 = function (value) {
    // Inline function 'kotlin.toUInt' call
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(value);
    return this.ums(UInt__toString_impl_dbgl21(tmp$ret$0));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).n75 = function (value) {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(value);
    return this.ums(ULong__toString_impl_f9au7k(tmp$ret$0));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).k75 = function (value) {
    // Inline function 'kotlin.toUByte' call
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(value);
    return this.ums(UByte__toString_impl_v72jg(tmp$ret$0));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).l75 = function (value) {
    // Inline function 'kotlin.toUShort' call
    var tmp$ret$0 = _UShort___init__impl__jigrne(value);
    return this.ums(UShort__toString_impl_edaoee(tmp$ret$0));
  };
  function AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1(this$0, $tag, $inlineDescriptor) {
    this.vms_1 = this$0;
    this.wms_1 = $tag;
    this.xms_1 = $inlineDescriptor;
    AbstractEncoder.call(this);
  }
  protoOf(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1).c75 = function () {
    return this.vms_1.qmr_1.c75();
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1).r75 = function (value) {
    return this.vms_1.cms(this.wms_1, new JsonLiteral(value, false, this.xms_1));
  };
  function AbstractJsonTreeEncoder$beginStructure$lambda(this$0) {
    return function (node) {
      this$0.cms(this$0.f7k(), node);
      return Unit_instance;
    };
  }
  function AbstractJsonTreeEncoder(json, nodeConsumer) {
    NamedValueEncoder.call(this);
    this.qmr_1 = json;
    this.rmr_1 = nodeConsumer;
    this.smr_1 = this.qmr_1.img_1;
    this.tmr_1 = null;
    this.umr_1 = null;
  }
  protoOf(AbstractJsonTreeEncoder).pmi = function () {
    return this.qmr_1;
  };
  protoOf(AbstractJsonTreeEncoder).c75 = function () {
    return this.qmr_1.c75();
  };
  protoOf(AbstractJsonTreeEncoder).s7i = function (descriptor, index) {
    return getJsonElementName(descriptor, this.qmr_1, index);
  };
  protoOf(AbstractJsonTreeEncoder).amk = function (element) {
    var tmp;
    if (!(this.tmr_1 == null)) {
      tmp = !(element instanceof JsonObject);
    } else {
      tmp = false;
    }
    if (tmp) {
      throwJsonElementPolymorphicException(this.umr_1, element);
    }
    this.f76(JsonElementSerializer_getInstance(), element);
  };
  protoOf(AbstractJsonTreeEncoder).k76 = function (descriptor, index) {
    return this.smr_1.xmh_1;
  };
  protoOf(AbstractJsonTreeEncoder).x7i = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeEncoder).i76 = function () {
  };
  protoOf(AbstractJsonTreeEncoder).i75 = function () {
    var tmp0_elvis_lhs = this.w7i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this.rmr_1(JsonNull_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tag = tmp;
    this.ems(tag);
  };
  protoOf(AbstractJsonTreeEncoder).ems = function (tag) {
    return this.cms(tag, JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeEncoder).s7j = function (tag) {
    return this.ems((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeEncoder).fms = function (tag, value) {
    return this.cms(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).t7j = function (tag, value) {
    return this.fms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).gms = function (tag, value) {
    return this.cms(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).u7j = function (tag, value) {
    return this.gms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).hms = function (tag, value) {
    return this.cms(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).v7j = function (tag, value) {
    return this.hms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).ims = function (tag, value) {
    return this.cms(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).w7j = function (tag, value) {
    return this.ims((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).jms = function (tag, value) {
    this.cms(tag, JsonPrimitive_1(value));
    if (!this.smr_1.hmi_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value, tag);
    }
  };
  protoOf(AbstractJsonTreeEncoder).x7j = function (tag, value) {
    return this.jms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).f76 = function (serializer, value) {
    if (!(this.w7i() == null) || !get_requiresTopLevelTag(carrierDescriptor(serializer.y70(), this.c75()))) {
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
        if (this.pmi().img_1.fmi_1) {
          serializer.z70(this, value);
          break $l$block;
        }
        var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
        var tmp;
        if (isPolymorphicSerializer) {
          tmp = !this.pmi().img_1.nmi_1.equals(ClassDiscriminatorMode_NONE_getInstance());
        } else {
          var tmp_0;
          switch (this.pmi().img_1.nmi_1.a1_1) {
            case 0:
            case 2:
              tmp_0 = false;
              break;
            case 1:
              // Inline function 'kotlin.let' call

              var it = serializer.y70().u72();
              tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        }
        var needDiscriminator = tmp;
        var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.y70(), this.pmi()) : null;
        var tmp_1;
        if (isPolymorphicSerializer) {
          var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
          $l$block_0: {
            // Inline function 'kotlin.requireNotNull' call
            if (value == null) {
              var message = 'Value for serializer ' + toString(serializer.y70()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
              throw IllegalArgumentException_init_$Create$(toString(message));
            } else {
              break $l$block_0;
            }
          }
          var actual = findPolymorphicSerializer_0(casted, this, value);
          tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
        } else {
          tmp_1 = serializer;
        }
        var actualSerializer = tmp_1;
        if (!(baseClassDiscriminator == null)) {
          access$checkEncodingConflicts$tPolymorphicKt(this.pmi(), serializer, actualSerializer, baseClassDiscriminator);
          checkKind_0(actualSerializer.y70().u72());
          var serialName = actualSerializer.y70().z71();
          this.tmr_1 = baseClassDiscriminator;
          this.umr_1 = serialName;
        }
        actualSerializer.z70(this, value);
      }
    } else {
      // Inline function 'kotlin.run' call
      (new JsonPrimitiveEncoder(this.qmr_1, this.rmr_1)).f76(serializer, value);
    }
  };
  protoOf(AbstractJsonTreeEncoder).kms = function (tag, value) {
    this.cms(tag, JsonPrimitive_1(value));
    if (!this.smr_1.hmi_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value, tag);
    }
  };
  protoOf(AbstractJsonTreeEncoder).y7j = function (tag, value) {
    return this.kms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).lms = function (tag, value) {
    return this.cms(tag, JsonPrimitive_2(value));
  };
  protoOf(AbstractJsonTreeEncoder).z7j = function (tag, value) {
    return this.lms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).mms = function (tag, value) {
    return this.cms(tag, JsonPrimitive_0(toString_1(value)));
  };
  protoOf(AbstractJsonTreeEncoder).a7k = function (tag, value) {
    return this.mms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).nms = function (tag, value) {
    return this.cms(tag, JsonPrimitive_0(value));
  };
  protoOf(AbstractJsonTreeEncoder).b7k = function (tag, value) {
    return this.nms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).oms = function (tag, enumDescriptor, ordinal) {
    return this.cms(tag, JsonPrimitive_0(enumDescriptor.y72(ordinal)));
  };
  protoOf(AbstractJsonTreeEncoder).c7k = function (tag, enumDescriptor, ordinal) {
    return this.oms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor, ordinal);
  };
  protoOf(AbstractJsonTreeEncoder).pms = function (tag, value) {
    this.cms(tag, JsonPrimitive_0(toString(value)));
  };
  protoOf(AbstractJsonTreeEncoder).q7j = function (tag, value) {
    return this.pms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).qms = function (tag, inlineDescriptor) {
    return get_isUnsignedNumber(inlineDescriptor) ? inlineUnsignedNumberEncoder(this, tag) : get_isUnquotedLiteral(inlineDescriptor) ? inlineUnquotedLiteralEncoder(this, tag, inlineDescriptor) : protoOf(NamedValueEncoder).d7k.call(this, tag, inlineDescriptor);
  };
  protoOf(AbstractJsonTreeEncoder).d7k = function (tag, inlineDescriptor) {
    return this.qms((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeEncoder).t75 = function (descriptor) {
    var tmp;
    if (!(this.w7i() == null)) {
      if (!(this.tmr_1 == null))
        this.umr_1 = descriptor.z71();
      tmp = protoOf(NamedValueEncoder).t75.call(this, descriptor);
    } else {
      tmp = (new JsonPrimitiveEncoder(this.qmr_1, this.rmr_1)).t75(descriptor);
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeEncoder).n74 = function (descriptor) {
    var tmp;
    if (this.w7i() == null) {
      tmp = this.rmr_1;
    } else {
      tmp = AbstractJsonTreeEncoder$beginStructure$lambda(this);
    }
    var consumer = tmp;
    var tmp0_subject = descriptor.u72();
    var tmp_0;
    var tmp_1;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_1) {
      tmp_0 = new JsonTreeListEncoder(this.qmr_1, consumer);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.qmr_1;
        var keyDescriptor = carrierDescriptor(descriptor.b73(0), this_0.c75());
        var keyKind = keyDescriptor.u72();
        var tmp_2;
        var tmp_3;
        if (keyKind instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          tmp_3 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_3) {
          tmp_2 = new JsonTreeMapEncoder(this.qmr_1, consumer);
        } else {
          if (this_0.img_1.ami_1) {
            tmp_2 = new JsonTreeListEncoder(this.qmr_1, consumer);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = new JsonTreeEncoder(this.qmr_1, consumer);
      }
    }
    var encoder = tmp_0;
    var discriminator = this.tmr_1;
    if (!(discriminator == null)) {
      if (encoder instanceof JsonTreeMapEncoder) {
        encoder.cms('key', JsonPrimitive_0(discriminator));
        var tmp1_elvis_lhs = this.umr_1;
        encoder.cms('value', JsonPrimitive_0(tmp1_elvis_lhs == null ? descriptor.z71() : tmp1_elvis_lhs));
      } else {
        var tmp2_elvis_lhs = this.umr_1;
        encoder.cms(discriminator, JsonPrimitive_0(tmp2_elvis_lhs == null ? descriptor.z71() : tmp2_elvis_lhs));
      }
      this.tmr_1 = null;
      this.umr_1 = null;
    }
    return encoder;
  };
  protoOf(AbstractJsonTreeEncoder).e7k = function (descriptor) {
    this.rmr_1(this.dms());
  };
  function get_requiresTopLevelTag(_this__u8e3s4) {
    var tmp;
    var tmp_0 = _this__u8e3s4.u72();
    if (tmp_0 instanceof PrimitiveKind) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4.u72() === ENUM_getInstance();
    }
    return tmp;
  }
  function JsonPrimitiveEncoder(json, nodeConsumer) {
    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
    this.nmt_1 = null;
    this.m7j('primitive');
  }
  protoOf(JsonPrimitiveEncoder).cms = function (key, element) {
    // Inline function 'kotlin.require' call
    if (!(key === 'primitive')) {
      var message = "This output can only consume primitives with 'primitive' tag";
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.nmt_1 == null)) {
      var message_0 = 'Primitive element was already recorded. Does call to .encodeXxx happen more than once?';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    this.nmt_1 = element;
    this.rmr_1(element);
  };
  protoOf(JsonPrimitiveEncoder).dms = function () {
    var tmp0 = this.nmt_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Primitive element has not been recorded. Is call to .encodeXxx is missing in serializer?';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$0;
  };
  function JsonTreeListEncoder(json, nodeConsumer) {
    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.umt_1 = ArrayList_init_$Create$();
  }
  protoOf(JsonTreeListEncoder).s7i = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListEncoder).cms = function (key, element) {
    var idx = toInt(key);
    this.umt_1.g3(idx, element);
  };
  protoOf(JsonTreeListEncoder).dms = function () {
    return new JsonArray(this.umt_1);
  };
  function _get_tag__e6h4qf($this) {
    var tmp = $this.fmt_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('tag');
    }
  }
  function JsonTreeMapEncoder(json, nodeConsumer) {
    JsonTreeEncoder.call(this, json, nodeConsumer);
    this.gmt_1 = true;
  }
  protoOf(JsonTreeMapEncoder).cms = function (key, element) {
    if (this.gmt_1) {
      var tmp = this;
      var tmp_0;
      if (element instanceof JsonPrimitive) {
        tmp_0 = element.rj3();
      } else {
        if (element instanceof JsonObject) {
          throw InvalidKeyKindException(JsonObjectSerializer_getInstance().mmj_1);
        } else {
          if (element instanceof JsonArray) {
            throw InvalidKeyKindException(JsonArraySerializer_getInstance().nmj_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
      tmp.fmt_1 = tmp_0;
      this.gmt_1 = false;
    } else {
      var tmp0 = this.bms_1;
      // Inline function 'kotlin.collections.set' call
      var key_0 = _get_tag__e6h4qf(this);
      tmp0.z2(key_0, element);
      this.gmt_1 = true;
    }
  };
  protoOf(JsonTreeMapEncoder).dms = function () {
    return new JsonObject(this.bms_1);
  };
  function writeJson$lambda($result) {
    return function (it) {
      $result._v = it;
      return Unit_instance;
    };
  }
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_instance;
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
    WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  }
  var $ENTRIES;
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this.ymo_1 = begin;
    this.zmo_1 = end;
  }
  function switchMode(_this__u8e3s4, desc) {
    var tmp0_subject = desc.u72();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
          var keyDescriptor = carrierDescriptor(desc.b73(0), _this__u8e3s4.c75());
          var keyKind = keyDescriptor.u72();
          var tmp_0;
          var tmp_1;
          if (keyKind instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            tmp_1 = equals(keyKind, ENUM_getInstance());
          }
          if (tmp_1) {
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this__u8e3s4.img_1.ami_1) {
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              throw InvalidKeyKindException(keyDescriptor);
            }
          }
          tmp = tmp_0;
        } else {
          tmp = WriteMode_OBJ_getInstance();
        }
      }
    }
    return tmp;
  }
  function carrierDescriptor(_this__u8e3s4, module_0) {
    var tmp;
    if (equals(_this__u8e3s4.u72(), CONTEXTUAL_getInstance())) {
      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    } else if (_this__u8e3s4.v72()) {
      tmp = carrierDescriptor(_this__u8e3s4.b73(0), module_0);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function appendEscape($this, lastPosition, current) {
    $this.vmt(lastPosition, current);
    return appendEsc($this, current + 1 | 0);
  }
  function decodedString($this, lastPosition, currentPosition) {
    $this.vmt(lastPosition, currentPosition);
    var result = $this.bmh_1.toString();
    $this.bmh_1.jd(0);
    return result;
  }
  function takePeeked($this) {
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.amh_1);
    $this.amh_1 = null;
    return this_0;
  }
  function wasUnquotedString($this) {
    return !(charSequenceGet($this.wmt(), $this.ymg_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
  }
  function appendEsc($this, startPosition) {
    var currentPosition = startPosition;
    currentPosition = $this.xmt(currentPosition);
    if (currentPosition === -1) {
      $this.wml('Expected escape sequence to continue, got EOF');
    }
    var tmp = $this.wmt();
    var _unary__edvuaz = currentPosition;
    currentPosition = _unary__edvuaz + 1 | 0;
    var currentChar = charSequenceGet(tmp, _unary__edvuaz);
    if (currentChar === _Char___init__impl__6a9atx(117)) {
      return appendHex($this, $this.wmt(), currentPosition);
    }
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
    var c = escapeToChar(tmp$ret$0);
    if (c === _Char___init__impl__6a9atx(0)) {
      $this.wml("Invalid escaped char '" + toString_1(currentChar) + "'");
    }
    $this.bmh_1.s(c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    if ((startPos + 4 | 0) >= charSequenceLength(source)) {
      $this.ymg_1 = startPos;
      $this.ymt();
      if (($this.ymg_1 + 4 | 0) >= charSequenceLength(source)) {
        $this.wml('Unexpected EOF during unicode escape');
      }
      return appendHex($this, source, $this.ymg_1);
    }
    $this.bmh_1.s(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
    return startPos + 4 | 0;
  }
  function fromHexChar($this, source, currentPosition) {
    var character = charSequenceGet(source, currentPosition);
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
      // Inline function 'kotlin.code' call
      var tmp_0 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
    } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
      // Inline function 'kotlin.code' call
      var tmp_1 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
      // Inline function 'kotlin.code' call
      var tmp_2 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
    } else {
      $this.wml("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
    }
    return tmp;
  }
  function consumeBoolean2($this, start) {
    var current = $this.xmt(start);
    if (current >= charSequenceLength($this.wmt()) || current === -1) {
      $this.wml('EOF');
    }
    var tmp = $this.wmt();
    var _unary__edvuaz = current;
    current = _unary__edvuaz + 1 | 0;
    // Inline function 'kotlin.code' call
    var this_0 = charSequenceGet(tmp, _unary__edvuaz);
    var tmp0_subject = Char__toInt_impl_vasixd(this_0) | 32;
    var tmp_0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(116);
    if (tmp0_subject === Char__toInt_impl_vasixd(this_1)) {
      consumeBooleanLiteral($this, 'rue', current);
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(102);
      if (tmp0_subject === Char__toInt_impl_vasixd(this_2)) {
        consumeBooleanLiteral($this, 'alse', current);
        tmp_0 = false;
      } else {
        $this.wml("Expected valid boolean literal prefix, but had '" + $this.emn() + "'");
      }
    }
    return tmp_0;
  }
  function consumeBooleanLiteral($this, literalSuffix, current) {
    if ((charSequenceLength($this.wmt()) - current | 0) < literalSuffix.length) {
      $this.wml('Unexpected end of boolean literal');
    }
    var inductionVariable = 0;
    var last = charSequenceLength(literalSuffix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var expected = charCodeAt(literalSuffix, i);
        var actual = charSequenceGet($this.wmt(), current + i | 0);
        // Inline function 'kotlin.code' call
        var tmp = Char__toInt_impl_vasixd(expected);
        // Inline function 'kotlin.code' call
        if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
          $this.wml("Expected valid boolean literal prefix, but had '" + $this.emn() + "'");
        }
      }
       while (inductionVariable <= last);
    $this.ymg_1 = current + literalSuffix.length | 0;
  }
  function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
    var tmp;
    switch (isExponentPositive) {
      case false:
        // Inline function 'kotlin.math.pow' call

        var x = -toNumber(exponentAccumulator);
        tmp = Math.pow(10.0, x);
        break;
      case true:
        // Inline function 'kotlin.math.pow' call

        var x_0 = toNumber(exponentAccumulator);
        tmp = Math.pow(10.0, x_0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function AbstractJsonLexer(configuration) {
    this.xmg_1 = configuration;
    this.ymg_1 = 0;
    this.zmg_1 = new JsonPath(this.xmg_1);
    this.amh_1 = null;
    this.bmh_1 = StringBuilder_init_$Create$();
  }
  protoOf(AbstractJsonLexer).ymt = function () {
  };
  protoOf(AbstractJsonLexer).omo = function () {
    var current = this.zmt();
    var source = this.wmt();
    if (current >= charSequenceLength(source) || current === -1)
      return false;
    if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
      this.ymg_1 = this.ymg_1 + 1 | 0;
      return true;
    }
    return false;
  };
  protoOf(AbstractJsonLexer).amu = function (c) {
    return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
  };
  protoOf(AbstractJsonLexer).cmh = function () {
    var nextToken = this.gmn();
    if (!(nextToken === 10)) {
      this.wml('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.wmt(), this.ymg_1 - 1 | 0)) + ' instead');
    }
  };
  protoOf(AbstractJsonLexer).amn = function (expected) {
    var token = this.gmn();
    if (!(token === expected)) {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
      var expected_0 = tokenDescription(expected);
      var position = true && this.ymg_1 > 0 ? this.ymg_1 - 1 | 0 : this.ymg_1;
      var s = this.ymg_1 === charSequenceLength(this.wmt()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.wmt(), position));
      var tmp$ret$1 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
      this.wml(tmp$ret$1, position);
    }
    return token;
  };
  protoOf(AbstractJsonLexer).bmu = function (expected) {
    if (this.ymg_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
        var snapshot = this.ymg_1;
        try {
          this.ymg_1 = this.ymg_1 - 1 | 0;
          tmp$ret$0 = this.emn();
          break $l$block;
        }finally {
          this.ymg_1 = snapshot;
        }
      }
      var inputLiteral = tmp$ret$0;
      if (inputLiteral === 'null') {
        this.vml("Expected string literal but 'null' literal was found", this.ymg_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
      }
    }
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
    var expectedToken = charToTokenClass(expected);
    var expected_0 = tokenDescription(expectedToken);
    var position = true && this.ymg_1 > 0 ? this.ymg_1 - 1 | 0 : this.ymg_1;
    var s = this.ymg_1 === charSequenceLength(this.wmt()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.wmt(), position));
    var tmp$ret$3 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
    this.wml(tmp$ret$3, position);
  };
  protoOf(AbstractJsonLexer).bmn = function () {
    var source = this.wmt();
    var cpos = this.ymg_1;
    $l$loop_0: while (true) {
      cpos = this.xmt(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.ymg_1 = cpos;
      return charToTokenClass(ch);
    }
    this.ymg_1 = cpos;
    return 10;
  };
  protoOf(AbstractJsonLexer).pmo = function (doConsume) {
    var current = this.zmt();
    current = this.xmt(current);
    var len = charSequenceLength(this.wmt()) - current | 0;
    if (len < 4 || current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charCodeAt('null', i) === charSequenceGet(this.wmt(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 && charToTokenClass(charSequenceGet(this.wmt(), current + 4 | 0)) === 0)
      return false;
    if (doConsume) {
      this.ymg_1 = current + 4 | 0;
    }
    return true;
  };
  protoOf(AbstractJsonLexer).amp = function (doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.pmo(doConsume) : $super.pmo.call(this, doConsume);
  };
  protoOf(AbstractJsonLexer).qmo = function (isLenient) {
    var token = this.bmn();
    var tmp;
    if (isLenient) {
      if (!(token === 1) && !(token === 0))
        return null;
      tmp = this.emn();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.dmn();
    }
    var string = tmp;
    this.amh_1 = string;
    return string;
  };
  protoOf(AbstractJsonLexer).cmu = function () {
    this.amh_1 = null;
  };
  protoOf(AbstractJsonLexer).dmu = function (startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.wmt();
    return toString(charSequenceSubSequence(this_0, startPos, endPos));
  };
  protoOf(AbstractJsonLexer).dmn = function () {
    if (!(this.amh_1 == null)) {
      return takePeeked(this);
    }
    return this.tmo();
  };
  protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.xmt(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.wml('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.vmt(lastPosition, currentPosition);
          currentPosition = this.xmt(currentPosition);
          if (currentPosition === -1) {
            this.wml('Unexpected EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.dmu(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.ymg_1 = currentPosition + 1 | 0;
    return string;
  };
  protoOf(AbstractJsonLexer).umo = function () {
    var result = this.emn();
    if (result === 'null' && wasUnquotedString(this)) {
      this.wml("Unexpected 'null' value instead of string literal");
    }
    return result;
  };
  protoOf(AbstractJsonLexer).emn = function () {
    if (!(this.amh_1 == null)) {
      return takePeeked(this);
    }
    var current = this.zmt();
    if (current >= charSequenceLength(this.wmt()) || current === -1) {
      this.wml('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.wmt(), current));
    if (token === 1) {
      return this.dmn();
    }
    if (!(token === 0)) {
      this.wml('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.wmt(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.wmt(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.wmt())) {
        usedAppend = true;
        this.vmt(this.ymg_1, current);
        var eof = this.xmt(current);
        if (eof === -1) {
          this.ymg_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.dmu(this.ymg_1, current);
    } else {
      tmp = decodedString(this, this.ymg_1, current);
    }
    var result = tmp;
    this.ymg_1 = current;
    return result;
  };
  protoOf(AbstractJsonLexer).vmt = function (fromIndex, toIndex) {
    this.bmh_1.bd(this.wmt(), fromIndex, toIndex);
  };
  protoOf(AbstractJsonLexer).smo = function (allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList_init_$Create$();
    var lastToken = this.bmn();
    if (!(lastToken === 8) && !(lastToken === 6)) {
      this.emn();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.bmn();
      if (lastToken === 1) {
        if (allowLenientStrings)
          this.emn();
        else
          this.tmo();
        continue $l$loop;
      }
      var tmp0_subject = lastToken;
      if (tmp0_subject === 8 || tmp0_subject === 6) {
        tokenStack.j1(lastToken);
      } else if (tmp0_subject === 9) {
        if (!(last(tokenStack) === 8)) {
          this.wml('found ] instead of }');
        }
        removeLast(tokenStack);
      } else if (tmp0_subject === 7) {
        if (!(last(tokenStack) === 6)) {
          this.wml('found } instead of ]');
        }
        removeLast(tokenStack);
      } else if (tmp0_subject === 10) {
        this.wml('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.gmn();
      if (tokenStack.n1() === 0)
        return Unit_instance;
    }
  };
  protoOf(AbstractJsonLexer).toString = function () {
    return "JsonReader(source='" + toString(this.wmt()) + "', currentPosition=" + this.ymg_1 + ')';
  };
  protoOf(AbstractJsonLexer).rmo = function (key) {
    var processed = this.dmu(0, this.ymg_1);
    var lastIndexOf_0 = lastIndexOf(processed, key);
    this.vml("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.");
  };
  protoOf(AbstractJsonLexer).vml = function (message, position, hint) {
    throw decodingExceptionOf_0(this, message, position, this.zmg_1.kmm(), hint, this.wmt());
  };
  protoOf(AbstractJsonLexer).wml = function (message, position, hint, $super) {
    position = position === VOID ? this.ymg_1 : position;
    hint = hint === VOID ? null : hint;
    return $super === VOID ? this.vml(message, position, hint) : $super.vml.call(this, message, position, hint);
  };
  protoOf(AbstractJsonLexer).cmp = function () {
    var current = this.zmt();
    current = this.xmt(current);
    if (current >= charSequenceLength(this.wmt()) || current === -1) {
      this.wml('EOF');
    }
    var tmp;
    if (charSequenceGet(this.wmt(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.wmt())) {
        this.wml('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var exponentAccumulator = new Long(0, 0);
    var isNegative = false;
    var isExponentPositive = false;
    var hasExponent = false;
    var start = current;
    $l$loop_4: while (!(current === charSequenceLength(this.wmt()))) {
      var ch = charSequenceGet(this.wmt(), current);
      if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
        if (current === start) {
          this.wml("Unexpected symbol '" + toString_1(ch) + "' in numeric literal", current);
        }
        isExponentPositive = true;
        hasExponent = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
        if (current === start) {
          this.wml("Unexpected symbol '-' in numeric literal", current);
        }
        isExponentPositive = false;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
        if (current === start) {
          this.wml("Unexpected symbol '+' in numeric literal", current);
        }
        isExponentPositive = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.wml("Unexpected symbol '-' in numeric literal", current);
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_4;
      current = current + 1 | 0;
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.wml("Unexpected symbol '" + toString_1(ch) + "' in numeric literal", current - 1 | 0);
      }
      if (hasExponent) {
        // Inline function 'kotlin.Long.times' call
        var this_0 = exponentAccumulator;
        // Inline function 'kotlin.Long.plus' call
        var this_1 = multiply(this_0, fromInt(10));
        exponentAccumulator = add(this_1, fromInt(digit));
        continue $l$loop_4;
      }
      // Inline function 'kotlin.Long.times' call
      var this_2 = accumulator;
      // Inline function 'kotlin.Long.minus' call
      var this_3 = multiply(this_2, fromInt(10));
      accumulator = subtract(this_3, fromInt(digit));
      if (compare(accumulator, new Long(0, 0)) > 0) {
        this.wml('Numeric value overflow');
      }
    }
    var hasChars = !(current === start);
    if (start === current || (isNegative && start === (current - 1 | 0))) {
      this.wml('Expected numeric literal', current);
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.wml('EOF');
      }
      if (!(charSequenceGet(this.wmt(), current) === _Char___init__impl__6a9atx(34))) {
        this.wml('Expected closing quotation mark', current);
      }
      current = current + 1 | 0;
    }
    this.ymg_1 = current;
    if (hasExponent) {
      var doubleAccumulator = toNumber(accumulator) * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
      if (doubleAccumulator > toNumber(new Long(-1, 2147483647)) || doubleAccumulator < toNumber(new Long(0, -2147483648))) {
        this.wml('Numeric value overflow');
      }
      // Inline function 'kotlin.math.floor' call
      if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
        this.wml("Can't convert " + doubleAccumulator + ' to Long');
      }
      accumulator = numberToLong(doubleAccumulator);
    }
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else if (!equalsLong(accumulator, new Long(0, -2147483648))) {
      tmp_0 = negate(accumulator);
    } else {
      this.wml('Numeric value overflow');
    }
    return tmp_0;
  };
  protoOf(AbstractJsonLexer).emj = function () {
    var result = this.cmp();
    var next = this.gmn();
    if (!(next === 10)) {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
      var expected = tokenDescription(10);
      var position = true && this.ymg_1 > 0 ? this.ymg_1 - 1 | 0 : this.ymg_1;
      var s = this.ymg_1 === charSequenceLength(this.wmt()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.wmt(), position));
      var tmp$ret$1 = "Expected input to contain a single valid number, but got '" + s + "' after it";
      this.wml(tmp$ret$1, position);
    }
    return result;
  };
  protoOf(AbstractJsonLexer).bmp = function () {
    var current = this.zmt();
    if (current === charSequenceLength(this.wmt())) {
      this.wml('EOF');
    }
    var tmp;
    if (charSequenceGet(this.wmt(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean2(this, current);
    if (hasQuotation) {
      if (this.ymg_1 === charSequenceLength(this.wmt())) {
        this.wml('EOF');
      }
      if (!(charSequenceGet(this.wmt(), this.ymg_1) === _Char___init__impl__6a9atx(34))) {
        this.wml('Expected closing quotation mark');
      }
      this.ymg_1 = this.ymg_1 + 1 | 0;
    }
    return result;
  };
  function tokenDescription(token) {
    return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
  }
  function charToTokenClass(c) {
    var tmp;
    // Inline function 'kotlin.code' call
    if (Char__toInt_impl_vasixd(c) < 126) {
      var tmp_0 = CharMappings_getInstance().fmu_1;
      // Inline function 'kotlin.code' call
      tmp = tmp_0[Char__toInt_impl_vasixd(c)];
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function escapeToChar(c) {
    return c < 117 ? CharMappings_getInstance().emu_1[c] : _Char___init__impl__6a9atx(0);
  }
  function initEscape($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC($this, i, _Char___init__impl__6a9atx(117));
      }
       while (inductionVariable <= 31);
    initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
    initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
    initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
    initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
    initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
    initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
    initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
    initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
  }
  function initCharToToken($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC($this, i, 127);
      }
       while (inductionVariable <= 32);
    initC2TC($this, 9, 3);
    initC2TC($this, 10, 3);
    initC2TC($this, 13, 3);
    initC2TC($this, 32, 3);
    initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
    initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
    initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
    initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
    initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
    initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
    initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
    initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
  }
  function initC2ESC($this, c, esc) {
    if (!(esc === _Char___init__impl__6a9atx(117))) {
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
      $this.emu_1[tmp$ret$0] = numberToChar(c);
    }
  }
  function initC2ESC_0($this, c, esc) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2ESC($this, tmp$ret$0, esc);
  }
  function initC2TC($this, c, cl) {
    $this.fmu_1[c] = cl;
  }
  function initC2TC_0($this, c, cl) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2TC($this, tmp$ret$0, cl);
  }
  function CharMappings() {
    CharMappings_instance = this;
    this.emu_1 = charArray(117);
    this.fmu_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
  var CharMappings_instance;
  function CharMappings_getInstance() {
    if (CharMappings_instance == null)
      new CharMappings();
    return CharMappings_instance;
  }
  function StringJsonLexerWithComments(source, configuration) {
    StringJsonLexer.call(this, source, configuration);
  }
  protoOf(StringJsonLexerWithComments).gmn = function () {
    var source = this.wmt();
    var cpos = this.zmt();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.ymg_1 = cpos + 1 | 0;
    return charToTokenClass(charCodeAt(source, cpos));
  };
  protoOf(StringJsonLexerWithComments).cmn = function () {
    var current = this.zmt();
    if (current >= this.wmt().length || current === -1)
      return false;
    return this.amu(charCodeAt(this.wmt(), current));
  };
  protoOf(StringJsonLexerWithComments).nmo = function (expected) {
    var source = this.wmt();
    var current = this.zmt();
    if (current >= source.length || current === -1) {
      this.ymg_1 = -1;
      this.bmu(expected);
    }
    var c = charCodeAt(source, current);
    this.ymg_1 = current + 1 | 0;
    if (c === expected)
      return Unit_instance;
    else {
      this.bmu(expected);
    }
  };
  protoOf(StringJsonLexerWithComments).bmn = function () {
    var source = this.wmt();
    var cpos = this.zmt();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.ymg_1 = cpos;
    return charToTokenClass(charCodeAt(source, cpos));
  };
  protoOf(StringJsonLexerWithComments).zmt = function () {
    var current = this.ymg_1;
    if (current === -1)
      return current;
    var source = this.wmt();
    $l$loop_1: while (current < source.length) {
      var c = charCodeAt(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop_1;
      }
      if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
        var tmp0_subject = charCodeAt(source, current + 1 | 0);
        if (tmp0_subject === _Char___init__impl__6a9atx(47)) {
          current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
          if (current === -1) {
            current = source.length;
          } else {
            current = current + 1 | 0;
          }
          continue $l$loop_1;
        } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
          current = indexOf(source, '*/', current + 2 | 0);
          if (current === -1) {
            this.ymg_1 = source.length;
            this.wml('Expected end of the block comment: "*/", but had EOF instead');
          } else {
            current = current + 2 | 0;
          }
          continue $l$loop_1;
        }
      }
      break $l$loop_1;
    }
    this.ymg_1 = current;
    return current;
  };
  function StringJsonLexer(source, configuration) {
    AbstractJsonLexer.call(this, configuration);
    this.rmu_1 = source;
  }
  protoOf(StringJsonLexer).wmt = function () {
    return this.rmu_1;
  };
  protoOf(StringJsonLexer).xmt = function (position) {
    return position < this.wmt().length ? position : -1;
  };
  protoOf(StringJsonLexer).gmn = function () {
    var source = this.wmt();
    var cpos = this.ymg_1;
    $l$loop: while (!(cpos === -1) && cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charCodeAt(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.ymg_1 = cpos;
      return charToTokenClass(c);
    }
    this.ymg_1 = source.length;
    return 10;
  };
  protoOf(StringJsonLexer).cmn = function () {
    var current = this.ymg_1;
    if (current === -1)
      return false;
    var source = this.wmt();
    $l$loop: while (current < source.length) {
      var c = charCodeAt(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.ymg_1 = current;
      return this.amu(c);
    }
    this.ymg_1 = current;
    return false;
  };
  protoOf(StringJsonLexer).zmt = function () {
    var current = this.ymg_1;
    if (current === -1)
      return current;
    var source = this.wmt();
    $l$loop: while (current < source.length) {
      var c = charCodeAt(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.ymg_1 = current;
    return current;
  };
  protoOf(StringJsonLexer).nmo = function (expected) {
    if (this.ymg_1 === -1) {
      this.bmu(expected);
    }
    var source = this.wmt();
    var cpos = this.ymg_1;
    $l$loop: while (cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charCodeAt(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.ymg_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.bmu(expected);
    }
    this.ymg_1 = -1;
    this.bmu(expected);
  };
  protoOf(StringJsonLexer).tmo = function () {
    this.nmo(_Char___init__impl__6a9atx(34));
    var current = this.ymg_1;
    var closingQuote = indexOf_0(this.wmt(), _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.emn();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
      var expected = tokenDescription(1);
      var position = false && this.ymg_1 > 0 ? this.ymg_1 - 1 | 0 : this.ymg_1;
      var s = this.ymg_1 === charSequenceLength(this.wmt()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.wmt(), position));
      var tmp$ret$1 = 'Expected ' + expected + ", but had '" + s + "' instead";
      this.wml(tmp$ret$1, position);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charCodeAt(this.wmt(), i) === _Char___init__impl__6a9atx(92)) {
          return this.consumeString2(this.wmt(), this.ymg_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.ymg_1 = closingQuote + 1 | 0;
    return substring(this.wmt(), current, closingQuote);
  };
  protoOf(StringJsonLexer).vmo = function (keyToMatch, isLenient) {
    var positionSnapshot = this.ymg_1;
    try {
      if (!(this.gmn() === 6))
        return null;
      var firstKey = this.qmo(isLenient);
      if (!(firstKey === keyToMatch))
        return null;
      this.cmu();
      if (!(this.gmn() === 5))
        return null;
      return this.qmo(isLenient);
    }finally {
      this.ymg_1 = positionSnapshot;
      this.cmu();
    }
  };
  function StringJsonLexer_0(json, source) {
    return !json.img_1.mmi_1 ? new StringJsonLexer(source, json.img_1) : new StringJsonLexerWithComments(source, json.img_1);
  }
  function get_schemaCache(_this__u8e3s4) {
    return _this__u8e3s4.kmg_1;
  }
  function JsonToStringWriter() {
    this.omg_1 = StringBuilder_init_$Create$_0(128);
  }
  protoOf(JsonToStringWriter).aml = function (value) {
    this.omg_1.fd(value);
  };
  protoOf(JsonToStringWriter).umk = function (char) {
    this.omg_1.s(char);
  };
  protoOf(JsonToStringWriter).wmk = function (text) {
    this.omg_1.q(text);
  };
  protoOf(JsonToStringWriter).gml = function (text) {
    printQuoted(this.omg_1, text);
  };
  protoOf(JsonToStringWriter).r2v = function () {
    this.omg_1.kd();
  };
  protoOf(JsonToStringWriter).toString = function () {
    return this.omg_1.toString();
  };
  function createMapForCache(initialCapacity) {
    return HashMap_init_$Create$(initialCapacity);
  }
  //region block: post-declaration
  protoOf(defer$1).n72 = get_isNullable;
  protoOf(defer$1).v72 = get_isInline;
  protoOf(defer$1).x72 = get_annotations;
  defineProp(protoOf(JsonException), 'message', function () {
    return this.e();
  });
  protoOf(JsonSerializersModuleValidator).a7m = contextual;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Tombstone_instance = new Tombstone();
  RedactedKey_instance = new RedactedKey();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Default_getInstance;
  _.$_$.b = JsonElementSerializer_getInstance;
  _.$_$.c = JsonObjectSerializer_getInstance;
  _.$_$.d = JsonArray;
  _.$_$.e = JsonDecoder;
  _.$_$.f = JsonElement;
  _.$_$.g = JsonEncoder;
  _.$_$.h = JsonNull;
  _.$_$.i = JsonObjectBuilder;
  _.$_$.j = JsonObject;
  _.$_$.k = JsonPrimitive;
  _.$_$.l = Json_0;
  _.$_$.m = add_0;
  _.$_$.n = get_booleanOrNull;
  _.$_$.o = get_doubleOrNull;
  _.$_$.p = get_jsonArray;
  _.$_$.q = get_jsonObject;
  _.$_$.r = get_jsonPrimitive;
  _.$_$.s = putJsonArray;
  _.$_$.t = putJsonObject;
  _.$_$.u = put_1;
  _.$_$.v = put;
  _.$_$.w = put_0;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlinx-serialization-kotlinx-serialization-json.js.map
